const croatiaShape = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "id": "HR",
      "properties": {
        "name": "Croatia",
        "density": 0
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                16.515301560932013,
                46.50171057781757
              ],
              [
                16.52108930756957,
                46.49853233732428
              ],
              [
                16.564290817560607,
                46.47992894827136
              ],
              [
                16.577623329365,
                46.470652949295406
              ],
              [
                16.583721148363992,
                46.470652949295406
              ],
              [
                16.588061977687175,
                46.47956722417414
              ],
              [
                16.594263147395363,
                46.482977846817136
              ],
              [
                16.6021179575206,
                46.482047603856685
              ],
              [
                16.611109653807638,
                46.478068481728386
              ],
              [
                16.63767134789668,
                46.47447704943232
              ],
              [
                16.65927209159389,
                46.46419338793083
              ],
              [
                16.67746219828709,
                46.44869048408298
              ],
              [
                16.69358524468611,
                46.42962187525749
              ],
              [
                16.71239545963221,
                46.41267194659827
              ],
              [
                16.742884562410325,
                46.39962372196945
              ],
              [
                16.755080205340345,
                46.381872915661646
              ],
              [
                16.761901494342478,
                46.381872915661646
              ],
              [
                16.76934288766547,
                46.39610965013135
              ],
              [
                16.776474243682795,
                46.39287995059459
              ],
              [
                16.803449348298138,
                46.388694223386246
              ],
              [
                16.80789352001427,
                46.387350623990464
              ],
              [
                16.812337680460157,
                46.38502506395325
              ],
              [
                16.816575160474894,
                46.38197627940802
              ],
              [
                16.820915973141492,
                46.37810046708833
              ],
              [
                16.82753055074234,
                46.374017976075834
              ],
              [
                16.83021773094498,
                46.377351165837624
              ],
              [
                16.832388148870557,
                46.38192459753091
              ],
              [
                16.837659144366608,
                46.381872915661646
              ],
              [
                16.850474886684747,
                46.373061961615804
              ],
              [
                16.85941068472672,
                46.36475790637067
              ],
              [
                16.86546105506693,
                46.359135186560344
              ],
              [
                16.87507287812484,
                46.342857178429995
              ],
              [
                16.871765590418295,
                46.327199260749154
              ],
              [
                16.8793118801398,
                46.31206199120459
              ],
              [
                16.889232211792237,
                46.292162518283334
              ],
              [
                16.89605350659388,
                46.286271460093246
              ],
              [
                16.90328820926477,
                46.28193065615868
              ],
              [
                16.940701943473993,
                46.25149321134927
              ],
              [
                16.96529992694277,
                46.219453846044615
              ],
              [
                16.974808391803162,
                46.21056550829288
              ],
              [
                17.028035112112182,
                46.18048977079961
              ],
              [
                17.036303347848403,
                46.17299676181013
              ],
              [
                17.04126428448155,
                46.16219637473552
              ],
              [
                17.05294315929373,
                46.15346306448979
              ],
              [
                17.101208944007016,
                46.128193267605944
              ],
              [
                17.116195110818076,
                46.123128984330485
              ],
              [
                17.197327106381927,
                46.121165247647
              ],
              [
                17.208592571608726,
                46.11656607525483
              ],
              [
                17.248590128225963,
                46.08023753113957
              ],
              [
                17.254067827975017,
                46.07083239882536
              ],
              [
                17.266573530535627,
                46.03879306347798
              ],
              [
                17.268950639637126,
                46.028716094152934
              ],
              [
                17.27587528134501,
                46.01202460338677
              ],
              [
                17.291481566964546,
                46.007942199663994
              ],
              [
                17.30781131752722,
                46.00639188362189
              ],
              [
                17.316803021583233,
                45.99765861441359
              ],
              [
                17.30936161168513,
                45.99662504856643
              ],
              [
                17.296959271871817,
                45.99264599371236
              ],
              [
                17.29013797996944,
                45.9914574177097
              ],
              [
                17.290137983831183,
                45.98463616527451
              ],
              [
                17.30481408448223,
                45.981018754177896
              ],
              [
                17.306613216380764,
                45.97991408398292
              ],
              [
                17.31659631024844,
                45.97378404252275
              ],
              [
                17.327138306554065,
                45.972027085236
              ],
              [
                17.337887006841733,
                45.98463616527451
              ],
              [
                17.34367476712309,
                45.96753125949098
              ],
              [
                17.342124468932425,
                45.95864286346875
              ],
              [
                17.345328406592813,
                45.95569729481886
              ],
              [
                17.365275508097547,
                45.956730818184845
              ],
              [
                17.38915002152875,
                45.96308703372134
              ],
              [
                17.39969201742306,
                45.959934797982264
              ],
              [
                17.406203247179548,
                45.94365671969008
              ],
              [
                17.41157759497563,
                45.9466022653587
              ],
              [
                17.41540165007243,
                45.949702841863875
              ],
              [
                17.41819217858622,
                45.953010148107104
              ],
              [
                17.42666711008382,
                45.956730818184845
              ],
              [
                17.511933230380972,
                45.953940350274394
              ],
              [
                17.55430790334756,
                45.947790844577575
              ],
              [
                17.591101520621997,
                45.93621530847746
              ],
              [
                17.638437136731955,
                45.90133374540552
              ],
              [
                17.645775184569242,
                45.891825233397604
              ],
              [
                17.64691207130332,
                45.88371207841857
              ],
              [
                17.65207970982851,
                45.86882922380552
              ],
              [
                17.6532165929648,
                45.85735707567224
              ],
              [
                17.654669375003945,
                45.852113441036025
              ],
              [
                17.656523882456774,
                45.845419796341375
              ],
              [
                17.66468876252632,
                45.84164745519258
              ],
              [
                17.687323034558226,
                45.840613881035175
              ],
              [
                17.809176069670325,
                45.814413994873064
              ],
              [
                17.838218222524695,
                45.79963451505253
              ],
              [
                17.85795862112218,
                45.77586337076103
              ],
              [
                17.858061971368315,
                45.771729231393174
              ],
              [
                17.870050900637846,
                45.773486204252514
              ],
              [
                17.875735312789317,
                45.78066926746422
              ],
              [
                17.880489539458587,
                45.78852404462352
              ],
              [
                17.889791301133755,
                45.79214142842073
              ],
              [
                17.906234390134802,
                45.79214142842073
              ],
              [
                17.97536747313915,
                45.79214142842073
              ],
              [
                18.08047733537293,
                45.771729231393174
              ],
              [
                18.092052856373222,
                45.771729231393174
              ],
              [
                18.10290490370748,
                45.77462307807828
              ],
              [
                18.120164834504866,
                45.78340809750435
              ],
              [
                18.12894982942011,
                45.78537180981052
              ],
              [
                18.211218709421967,
                45.78537180981052
              ],
              [
                18.229822227569702,
                45.78123771518551
              ],
              [
                18.260518022721765,
                45.765114614458675
              ],
              [
                18.283255655456585,
                45.764907943108824
              ],
              [
                18.300515580402617,
                45.75183376964405
              ],
              [
                18.317672159961084,
                45.74728627464968
              ],
              [
                18.33493208946082,
                45.75198884411369
              ],
              [
                18.35115848784384,
                45.75839670759872
              ],
              [
                18.367178186137178,
                45.758190040068946
              ],
              [
                18.38381799097089,
                45.74320381882833
              ],
              [
                18.384128052598943,
                45.743100489363236
              ],
              [
                18.39074263425865,
                45.74180856736284
              ],
              [
                18.397563926709065,
                45.74134351024214
              ],
              [
                18.404385212258106,
                45.74180856736284
              ],
              [
                18.411723264967787,
                45.74320381882833
              ],
              [
                18.43074019272574,
                45.753642465619386
              ],
              [
                18.46546676014536,
                45.78371819692397
              ],
              [
                18.481796508974448,
                45.791417948772015
              ],
              [
                18.504224081119315,
                45.78402822005988
              ],
              [
                18.53026899941821,
                45.79084948508647
              ],
              [
                18.57347049593123,
                45.81668769684357
              ],
              [
                18.58545943516064,
                45.82691968594338
              ],
              [
                18.60737024097016,
                45.85668529938512
              ],
              [
                18.622149699694702,
                45.868415839123024
              ],
              [
                18.6235966432372,
                45.86867425234817
              ],
              [
                18.62628381171931,
                45.87482369971414
              ],
              [
                18.6292810473404,
                45.88686433080583
              ],
              [
                18.633001749478545,
                45.8919286054079
              ],
              [
                18.655636029887873,
                45.9075865933875
              ],
              [
                18.674342894382967,
                45.91037708179829
              ],
              [
                18.723848922222984,
                45.898439876998154
              ],
              [
                18.763329710523152,
                45.883970426083074
              ],
              [
                18.77552535383893,
                45.8828335905529
              ],
              [
                18.7859639913003,
                45.88691601609209
              ],
              [
                18.790408159984995,
                45.89389229640636
              ],
              [
                18.794852336892696,
                45.90303904978967
              ],
              [
                18.80487756373517,
                45.91363271741034
              ],
              [
                18.817796672567354,
                45.9054678399446
              ],
              [
                18.822450675713903,
                45.90558193636257
              ],
              [
                18.82833866242676,
                45.905726203294805
              ],
              [
                18.84539188767167,
                45.91394277584392
              ],
              [
                18.865442339576052,
                45.91807686293197
              ],
              [
                18.876604449451005,
                45.92241768286013
              ],
              [
                18.886526328661812,
                45.930427566422864
              ],
              [
                18.90130578751737,
                45.93120271115849
              ],
              [
                18.906990192292117,
                45.91569975318675
              ],
              [
                18.889833621255267,
                45.907896646580674
              ],
              [
                18.881978799387422,
                45.90262562567741
              ],
              [
                18.872883749368846,
                45.895235912898684
              ],
              [
                18.89345096558837,
                45.8838670563669
              ],
              [
                18.903992963978663,
                45.87570224454356
              ],
              [
                18.9069901971504,
                45.86795077235279
              ],
              [
                18.899755492805095,
                45.861387836306456
              ],
              [
                18.887146438942818,
                45.85947577472811
              ],
              [
                18.85531376096242,
                45.85735707567224
              ],
              [
                18.852419878718763,
                45.83007190011753
              ],
              [
                18.85035282698545,
                45.82423250902471
              ],
              [
                18.84673547237265,
                45.8199950018092
              ],
              [
                18.844978474683323,
                45.815705869237604
              ],
              [
                18.8486991760415,
                45.80955635891882
              ],
              [
                18.86399540371434,
                45.798549311942466
              ],
              [
                18.87112674825691,
                45.78997099380872
              ],
              [
                18.90016890447198,
                45.764907943108824
              ],
              [
                18.904819785172858,
                45.74976675421194
              ],
              [
                18.908953899314618,
                45.719432690451455
              ],
              [
                18.917325480995913,
                45.70656525567388
              ],
              [
                18.931071409252496,
                45.698917119787595
              ],
              [
                18.948124632681672,
                45.69204415853191
              ],
              [
                18.962697391015148,
                45.68305249621165
              ],
              [
                18.968485148925105,
                45.668738106041424
              ],
              [
                18.96290409216243,
                45.660108126714114
              ],
              [
                18.935412229758757,
                45.63339140818161
              ],
              [
                18.92445682806489,
                45.627707011565406
              ],
              [
                18.912364544096203,
                45.61923209429664
              ],
              [
                18.908230429927904,
                45.60042187183777
              ],
              [
                18.906990191911284,
                45.58166329174691
              ],
              [
                18.903579550891962,
                45.57308503853811
              ],
              [
                18.912054482833092,
                45.56822742780213
              ],
              [
                18.932001586854494,
                45.54554149146204
              ],
              [
                18.94171675569026,
                45.53892688856501
              ],
              [
                18.960216920972545,
                45.53913362420359
              ],
              [
                18.973136026046028,
                45.54626494568572
              ],
              [
                18.983161253675476,
                45.55473987646464
              ],
              [
                19.000627891020077,
                45.56119946057246
              ],
              [
                19.009206178279594,
                45.565488597124535
              ],
              [
                19.01809452282438,
                45.567400612472916
              ],
              [
                19.027189575978806,
                45.56259471550203
              ],
              [
                19.033390745551614,
                45.55463652341961
              ],
              [
                19.036491334704575,
                45.54946890780348
              ],
              [
                19.040935503933714,
                45.54502470105685
              ],
              [
                19.050960732682682,
                45.53892688856501
              ],
              [
                19.067807249413164,
                45.53339750823539
              ],
              [
                19.082276652090552,
                45.5311754367839
              ],
              [
                19.095092407710005,
                45.526059475150284
              ],
              [
                19.10625451594126,
                45.5116417358307
              ],
              [
                19.077212363196303,
                45.49164297537991
              ],
              [
                19.017926147888804,
                45.497807287734425
              ],
              [
                19.009619589219806,
                45.49867096961952
              ],
              [
                18.996390423513823,
                45.47381460919546
              ],
              [
                18.997144014329013,
                45.455516924300895
              ],
              [
                19.002282343164207,
                45.4436864415312
              ],
              [
                19.016432708800505,
                45.43355784989928
              ],
              [
                19.031318661018393,
                45.41620105544194
              ],
              [
                19.022619648768085,
                45.40239191533049
              ],
              [
                18.997352279415637,
                45.39977477467777
              ],
              [
                18.975527409599653,
                45.391129648464705
              ],
              [
                18.97749138667145,
                45.37120874626653
              ],
              [
                18.995688268133208,
                45.3622596090465
              ],
              [
                18.99643405440681,
                45.36208783728497
              ],
              [
                19.00752271156751,
                45.3595341321491
              ],
              [
                19.01416241939866,
                45.35342265868892
              ],
              [
                19.030239760533057,
                45.34513679703629
              ],
              [
                19.0529426373064,
                45.34539522691539
              ],
              [
                19.06719912617651,
                45.343425391645255
              ],
              [
                19.082956345180342,
                45.339224343997635
              ],
              [
                19.09622929114349,
                45.32912060364176
              ],
              [
                19.09881310995303,
                45.31987050359129
              ],
              [
                19.10414709105776,
                45.298725652174866
              ],
              [
                19.15848233181173,
                45.27617137137662
              ],
              [
                19.19717908591059,
                45.26492281184778
              ],
              [
                19.259906947288528,
                45.24297300313195
              ],
              [
                19.289749827169945,
                45.236310123360475
              ],
              [
                19.37807254932393,
                45.229591771193306
              ],
              [
                19.39729618324801,
                45.2232872551278
              ],
              [
                19.407838174581936,
                45.203133440412564
              ],
              [
                19.40535770806528,
                45.17967235214323
              ],
              [
                19.39392939888943,
                45.17162423045901
              ],
              [
                19.39068160015317,
                45.169337058315634
              ],
              [
                19.304278606080064,
                45.16654653932159
              ],
              [
                19.299421020553503,
                45.16897532677805
              ],
              [
                19.2913594971403,
                45.17770864021029
              ],
              [
                19.286708619030293,
                45.17951732289768
              ],
              [
                19.279473918464895,
                45.17724355501587
              ],
              [
                19.275753214255488,
                45.17285104756434
              ],
              [
                19.27275598136645,
                45.168355208167064
              ],
              [
                19.26779504442569,
                45.16582306268001
              ],
              [
                19.22593713399892,
                45.16194733565693
              ],
              [
                19.204543091592754,
                45.16287750814251
              ],
              [
                19.185319457272325,
                45.16804513968031
              ],
              [
                19.17457076109351,
                45.17579662049935
              ],
              [
                19.155760538662488,
                45.19496856406503
              ],
              [
                19.143874958894372,
                45.19951609208072
              ],
              [
                19.121860798836458,
                45.19579538857492
              ],
              [
                19.1287854400857,
                45.18106759903786
              ],
              [
                19.141704549728193,
                45.162154038338336
              ],
              [
                19.137673787028334,
                45.14603098624599
              ],
              [
                19.116073039317886,
                45.142878726771
              ],
              [
                19.060055786290015,
                45.14685781153524
              ],
              [
                19.044862914801637,
                45.1372459912631
              ],
              [
                19.04620650153269,
                45.12835764190793
              ],
              [
                19.05416467288051,
                45.1206061799533
              ],
              [
                19.064086547697098,
                45.113578183349304
              ],
              [
                19.071527954281038,
                45.1070669584571
              ],
              [
                19.079176065736274,
                45.09461293369305
              ],
              [
                19.082276651667154,
                45.084949440088245
              ],
              [
                19.085997355184137,
                45.06091990361033
              ],
              [
                19.094265584038336,
                45.03141265933441
              ],
              [
                19.09540246611835,
                45.0209223440346
              ],
              [
                19.093232055038506,
                45.011517233336896
              ],
              [
                19.088477809053835,
                44.9994764921352
              ],
              [
                19.085170550334865,
                44.987281137839204
              ],
              [
                19.087237574666776,
                44.977100602442235
              ],
              [
                19.09808962398158,
                44.97002091674152
              ],
              [
                19.11855352382992,
                44.975550583189566
              ],
              [
                19.127648548094044,
                44.968418983908975
              ],
              [
                19.131679318342446,
                44.953174516763674
              ],
              [
                19.124547962550228,
                44.9459397485872
              ],
              [
                19.113075822235277,
                44.94242598411638
              ],
              [
                19.103567349905553,
                44.938240120240344
              ],
              [
                19.087857712904338,
                44.9193265287737
              ],
              [
                19.0786592931007,
                44.91085146391294
              ],
              [
                19.066670356049638,
                44.905683785284445
              ],
              [
                19.052097602328832,
                44.906975698654115
              ],
              [
                19.03194381910109,
                44.92263387541748
              ],
              [
                19.018404595084025,
                44.92568279313652
              ],
              [
                18.991429496189223,
                44.91493408743649
              ],
              [
                18.994323353588047,
                44.894831756206585
              ],
              [
                19.01582076576259,
                44.865634714772945
              ],
              [
                19.00496871414935,
                44.863309270397075
              ],
              [
                18.974915928963423,
                44.86275731153049
              ],
              [
                18.88962692791996,
                44.8611906322171
              ],
              [
                18.858724415972596,
                44.86852863359374
              ],
              [
                18.842129489297207,
                44.8762394382163
              ],
              [
                18.8177966759634,
                44.88754550727353
              ],
              [
                18.783380165032444,
                44.913745405464155
              ],
              [
                18.772631479935797,
                44.94247761646202
              ],
              [
                18.779866185210476,
                44.95224449948323
              ],
              [
                18.801570277815948,
                44.96397497562766
              ],
              [
                18.804567497869435,
                44.97384504959399
              ],
              [
                18.80301721430098,
                44.97730745546022
              ],
              [
                18.797952916636948,
                44.9822166561949
              ],
              [
                18.795782508619318,
                44.985058868930075
              ],
              [
                18.795162385298035,
                44.988004378602454
              ],
              [
                18.795162394004954,
                44.99332712904373
              ],
              [
                18.794645629808933,
                44.99544586029986
              ],
              [
                18.79175174899859,
                45.00154368098654
              ],
              [
                18.788961221989844,
                45.00572947190936
              ],
              [
                18.784930461026182,
                45.00846832323261
              ],
              [
                18.778005818994554,
                45.01032867395101
              ],
              [
                18.750100546006784,
                45.01224070305985
              ],
              [
                18.738318319014517,
                45.015909729128644
              ],
              [
                18.726329385867615,
                45.02614166181796
              ],
              [
                18.689019001671433,
                45.08024688506516
              ],
              [
                18.684058064588225,
                45.08479441032197
              ],
              [
                18.678166951003988,
                45.08737823503534
              ],
              [
                18.67134566228535,
                45.08686147254951
              ],
              [
                18.666074665824652,
                45.082985737431706
              ],
              [
                18.66328413893218,
                45.07714630039265
              ],
              [
                18.661217081804505,
                45.07110015725119
              ],
              [
                18.658116495141762,
                45.06629425126766
              ],
              [
                18.648711384798972,
                45.06267689819934
              ],
              [
                18.64054650898394,
                45.06536407485606
              ],
              [
                18.633621867182,
                45.07197865962997
              ],
              [
                18.627937459088944,
                45.08004018279604
              ],
              [
                18.621116170066248,
                45.09311431959327
              ],
              [
                18.616671996605756,
                45.09766184146574
              ],
              [
                18.609127238210366,
                45.10009063888508
              ],
              [
                18.602512654246798,
                45.09926381721249
              ],
              [
                18.58856001797516,
                45.09321767177621
              ],
              [
                18.58184208161653,
                45.0913573175561
              ],
              [
                18.573780558509096,
                45.09156403057252
              ],
              [
                18.557657510846308,
                45.09440622861749
              ],
              [
                18.549595988261036,
                45.094767967346904
              ],
              [
                18.534919880862528,
                45.090427143761396
              ],
              [
                18.53480270458886,
                45.08841171429771
              ],
              [
                18.5344031170445,
                45.08153879939989
              ],
              [
                18.539260701821714,
                45.06934315839392
              ],
              [
                18.541121052759298,
                45.05528716883171
              ],
              [
                18.517039835159157,
                45.05585561343446
              ],
              [
                18.490788207879362,
                45.06278025190964
              ],
              [
                18.481708183941166,
                45.06692135146806
              ],
              [
                18.466086873040013,
                45.07404571636073
              ],
              [
                18.451829851739152,
                45.08495874264023
              ],
              [
                18.42929325360751,
                45.10220936844613
              ],
              [
                18.412033325434916,
                45.11244130893944
              ],
              [
                18.392913045407877,
                45.11864247969771
              ],
              [
                18.32232303871902,
                45.1228799414424
              ],
              [
                18.30744022746577,
                45.127530827241195
              ],
              [
                18.261964965666632,
                45.1506818619572
              ],
              [
                18.23788374824634,
                45.157451479249886
              ],
              [
                18.213285765782768,
                45.15378244801118
              ],
              [
                18.202330363112818,
                45.14406728203249
              ],
              [
                18.200056598870255,
                45.13161326081104
              ],
              [
                18.199333130022755,
                45.11900421220735
              ],
              [
                18.1925118409316,
                45.108513895372155
              ],
              [
                18.174941854519343,
                45.10076243576598
              ],
              [
                18.1536511645071,
                45.09755849766011
              ],
              [
                18.143698040326584,
                45.09770000800197
              ],
              [
                18.131843708702434,
                45.097868548261246
              ],
              [
                18.112413370754354,
                45.10060739973641
              ],
              [
                18.090295857284246,
                45.10799713361984
              ],
              [
                18.03500207467841,
                45.14334380902696
              ],
              [
                18.019085733547833,
                45.149441626817016
              ],
              [
                18.00347945109122,
                45.14933827884344
              ],
              [
                17.988493286150163,
                45.143808901391054
              ],
              [
                17.9277218024883,
                45.092029118544254
              ],
              [
                17.911185343357793,
                45.08107371433317
              ],
              [
                17.90260705581514,
                45.07776641727566
              ],
              [
                17.875218545895,
                45.073994038019
              ],
              [
                17.845659628239698,
                45.06526072524095
              ],
              [
                17.83573775217613,
                45.06443390064804
              ],
              [
                17.815583944082945,
                45.070169983776445
              ],
              [
                17.79749719253377,
                45.081952205627765
              ],
              [
                17.741376587236353,
                45.1332669092202
              ],
              [
                17.714504841757094,
                45.15202544971372
              ],
              [
                17.684739216769117,
                45.16396270582349
              ],
              [
                17.651562948172792,
                45.165357972630034
              ],
              [
                17.629962199438832,
                45.157348129146655
              ],
              [
                17.59306522565698,
                45.12959787674825
              ],
              [
                17.57239465344588,
                45.12039948023055
              ],
              [
                17.561439249795015,
                45.119365945052344
              ],
              [
                17.53952844281953,
                45.12096791428342
              ],
              [
                17.489298950471216,
                45.11626536549234
              ],
              [
                17.4818575437542,
                45.11440500665421
              ],
              [
                17.487025187032877,
                45.12086456431252
              ],
              [
                17.49622359206171,
                45.14169016558714
              ],
              [
                17.472349080140358,
                45.132750143338406
              ],
              [
                17.460360148016505,
                45.13125152615702
              ],
              [
                17.44775109873724,
                45.13430043348802
              ],
              [
                17.45498579933635,
                45.14060496321137
              ],
              [
                17.458086385407825,
                45.1461343428932
              ],
              [
                17.456949502672053,
                45.15181874286798
              ],
              [
                17.451161743466294,
                45.158485010452196
              ],
              [
                17.4433069247312,
                45.162050677431125
              ],
              [
                17.438759398887047,
                45.158123269919926
              ],
              [
                17.436175578214893,
                45.151922101053344
              ],
              [
                17.434108519574405,
                45.14856312693108
              ],
              [
                17.400828898276487,
                45.1410183746481
              ],
              [
                17.382432088023712,
                45.1396231092266
              ],
              [
                17.368582803616015,
                45.14510080631394
              ],
              [
                17.35938439868317,
                45.1506818619572
              ],
              [
                17.32651818732267,
                45.16592640548582
              ],
              [
                17.307811319515093,
                45.171404110331494
              ],
              [
                17.2689506422784,
                45.189542535040246
              ],
              [
                17.24972700980658,
                45.159880267130305
              ],
              [
                17.245489542538557,
                45.15538441554025
              ],
              [
                17.197843871907597,
                45.15295562710329
              ],
              [
                17.187095173580534,
                45.14856312693108
              ],
              [
                17.1246284324342,
                45.169057749494556
              ],
              [
                17.09841841555681,
                45.17765695768125
              ],
              [
                17.05573368395554,
                45.200446278327476
              ],
              [
                17.03630334471692,
                45.230470283001516
              ],
              [
                17.030205525716568,
                45.22695628600182
              ],
              [
                17.014392536198724,
                45.21977324716078
              ],
              [
                17.008294717064913,
                45.21615589584737
              ],
              [
                17.012532185869002,
                45.22447580871788
              ],
              [
                17.013565714486298,
                45.23057362397494
              ],
              [
                17.01201542037515,
                45.23646473588788
              ],
              [
                17.008294717092785,
                45.244164522125104
              ],
              [
                16.99868290162254,
                45.2314004483048
              ],
              [
                16.988140909743787,
                45.236516426284446
              ],
              [
                16.97594527034051,
                45.24716175753673
              ],
              [
                16.961165812933253,
                45.25093415215265
              ],
              [
                16.965299926668578,
                45.24421621355573
              ],
              [
                16.967987101700054,
                45.23729157286398
              ],
              [
                16.94731652848812,
                45.23568959097282
              ],
              [
                16.941528768812876,
                45.241218981982044
              ],
              [
                16.942148885048322,
                45.24984893947401
              ],
              [
                16.94070194589239,
                45.25775544176084
              ],
              [
                16.93264042077077,
                45.278787738748605
              ],
              [
                16.924372193569216,
                45.2845238305898
              ],
              [
                16.896983682495673,
                45.268142391035916
              ],
              [
                16.8939864507883,
                45.263543199759155
              ],
              [
                16.885821573620238,
                45.25522328325774
              ],
              [
                16.8753829358838,
                45.246955066711394
              ],
              [
                16.867321410575656,
                45.243389380813326
              ],
              [
                16.861740357041555,
                45.232227274409055
              ],
              [
                16.851921834677132,
                45.227421373686504
              ],
              [
                16.84075972526183,
                45.224010724586584
              ],
              [
                16.83073449704863,
                45.21698272748006
              ],
              [
                16.8250500898608,
                45.20504548051765
              ],
              [
                16.825773559683665,
                45.19636382786804
              ],
              [
                16.824223266075347,
                45.18907745474494
              ],
              [
                16.811717569182846,
                45.18122262890362
              ],
              [
                16.78629276528709,
                45.17884552384795
              ],
              [
                16.587028442155464,
                45.22085845152487
              ],
              [
                16.528944133835658,
                45.22225373241377
              ],
              [
                16.481918578909106,
                45.19951609208072
              ],
              [
                16.449155720549644,
                45.14809803843575
              ],
              [
                16.435513143045426,
                45.132853496459944
              ],
              [
                16.424764444750412,
                45.12727243846553
              ],
              [
                16.398512817451866,
                45.12143300859476
              ],
              [
                16.389211060203976,
                45.11683380307526
              ],
              [
                16.381769653899845,
                45.10758371897922
              ],
              [
                16.381976358791515,
                45.10195098687657
              ],
              [
                16.384043415615853,
                45.095439755087135
              ],
              [
                16.381976358575546,
                45.083709203675774
              ],
              [
                16.37732547987254,
                45.07559600770025
              ],
              [
                16.356964966207645,
                45.04862091311934
              ],
              [
                16.346019391946573,
                45.02001001145324
              ],
              [
                16.340635213013105,
                45.00593617813366
              ],
              [
                16.31624393699725,
                45.001233622971135
              ],
              [
                16.27934696497871,
                45.00717641178095
              ],
              [
                16.241209756978733,
                45.018958638780354
              ],
              [
                16.21299442594846,
                45.03146433446764
              ],
              [
                16.121527139636772,
                45.09616322524012
              ],
              [
                16.104060505872607,
                45.112544656680136
              ],
              [
                16.08276981645211,
                45.15161204568467
              ],
              [
                16.06747359271183,
                45.169595446380036
              ],
              [
                16.054967896376112,
                45.17641673190141
              ],
              [
                16.033057087599207,
                45.17972401583464
              ],
              [
                16.02437544682113,
                45.18432322013988
              ],
              [
                16.02499556468591,
                45.18892242173503
              ],
              [
                16.02871626789844,
                45.196260476944175
              ],
              [
                16.02923303282004,
                45.20504548051765
              ],
              [
                16.020448038243345,
                45.21393381013658
              ],
              [
                16.008459105591612,
                45.21817128075316
              ],
              [
                15.997503702910652,
                45.218533020069465
              ],
              [
                15.974559366572901,
                45.21538075354884
              ],
              [
                15.87885461401405,
                45.21724110914577
              ],
              [
                15.824801065201527,
                45.21098825259953
              ],
              [
                15.802568519632814,
                45.19647338866679
              ],
              [
                15.792348266380873,
                45.1898009174695
              ],
              [
                15.780979451714677,
                45.167993477544805
              ],
              [
                15.780049275901199,
                45.16029367995551
              ],
              [
                15.78376997921826,
                45.100917462305766
              ],
              [
                15.779429158422394,
                45.085362859465484
              ],
              [
                15.755968058835192,
                45.04221303125265
              ],
              [
                15.755554646990104,
                45.023557840894576
              ],
              [
                15.76744023308569,
                44.99322385111548
              ],
              [
                15.763616183876671,
                44.975550583189566
              ],
              [
                15.738811473507932,
                44.94485454473024
              ],
              [
                15.734108153537914,
                44.934440160259946
              ],
              [
                15.730853307412326,
                44.92723292319223
              ],
              [
                15.734263948763104,
                44.902118138348456
              ],
              [
                15.748009893096583,
                44.882016148205935
              ],
              [
                15.764029571233612,
                44.86403259119541
              ],
              [
                15.773434677635471,
                44.84501561535872
              ],
              [
                15.76868046783695,
                44.827342511329874
              ],
              [
                15.751213828201916,
                44.82155467979475
              ],
              [
                15.730646616549127,
                44.81700724379999
              ],
              [
                15.716073847510538,
                44.80320948608093
              ],
              [
                15.717314083014148,
                44.78646632744543
              ],
              [
                15.728476189623835,
                44.7691030199525
              ],
              [
                15.75369429493227,
                44.73928578627735
              ],
              [
                15.759275347033329,
                44.73416978837948
              ],
              [
                15.782839817009961,
                44.72259444913405
              ],
              [
                15.790487916670303,
                44.7133959127734
              ],
              [
                15.796999138181171,
                44.703267230811406
              ],
              [
                15.805680794874597,
                44.69665282438008
              ],
              [
                15.820356882265806,
                44.69825458595165
              ],
              [
                15.82996870211732,
                44.70052838992047
              ],
              [
                15.847848757367242,
                44.70151034010493
              ],
              [
                15.856427050429641,
                44.70357745074959
              ],
              [
                15.863868449531996,
                44.70998525563474
              ],
              [
                15.869242799793668,
                44.71856355598971
              ],
              [
                15.87627080093521,
                44.7248164805501
              ],
              [
                15.88877648642964,
                44.72424791782147
              ],
              [
                15.895597779796624,
                44.71856355598971
              ],
              [
                15.89931847118625,
                44.70920999927066
              ],
              [
                15.902005653263842,
                44.698823112077164
              ],
              [
                15.905416293483619,
                44.69014142055423
              ],
              [
                15.913064418005069,
                44.68450883244737
              ],
              [
                15.92153935762841,
                44.68611085123191
              ],
              [
                15.929807577009406,
                44.68946970709817
              ],
              [
                15.937352321952883,
                44.68895279382103
              ],
              [
                15.94810102733697,
                44.67810082074545
              ],
              [
                15.955645780521301,
                44.653192729967905
              ],
              [
                15.968978320219435,
                44.63924030061757
              ],
              [
                15.979106891655636,
                44.63438261583965
              ],
              [
                15.991612577820527,
                44.63143695533603
              ],
              [
                16.01600386084212,
                44.62895656030214
              ],
              [
                16.02830284411238,
                44.62471901215255
              ],
              [
                16.036157661537175,
                44.61531389515068
              ],
              [
                16.041118625342886,
                44.60280847007985
              ],
              [
                16.044735958438157,
                44.589372419603094
              ],
              [
                16.043185673355964,
                44.58844232773745
              ],
              [
                16.034917454242905,
                44.58539352163908
              ],
              [
                16.030473274354367,
                44.57221596982053
              ],
              [
                16.013936820880385,
                44.55702313605291
              ],
              [
                16.00608200135337,
                44.54100343560458
              ],
              [
                16.026649214324607,
                44.52519037351406
              ],
              [
                16.047319773194687,
                44.52332987393021
              ],
              [
                16.083700004578468,
                44.534905639372205
              ],
              [
                16.10488732741352,
                44.53237333638589
              ],
              [
                16.116462856019425,
                44.52146968800304
              ],
              [
                16.12307742095964,
                44.50389951198054
              ],
              [
                16.128348415455516,
                44.48431412922597
              ],
              [
                16.152946404271255,
                44.4350665596022
              ],
              [
                16.15966434961949,
                44.41610140740444
              ],
              [
                16.159871042445296,
                44.40070169254164
              ],
              [
                16.15387658720627,
                44.3935704571592
              ],
              [
                16.145401647439428,
                44.38959132221763
              ],
              [
                16.138787078144432,
                44.385405674854226
              ],
              [
                16.13827031919594,
                44.37760258683566
              ],
              [
                16.141991017720127,
                44.38075480187896
              ],
              [
                16.153153105524712,
                44.3804445218058
              ],
              [
                16.171343229558076,
                44.37708576254275
              ],
              [
                16.192117140301225,
                44.367422121436626
              ],
              [
                16.202865842007782,
                44.35977404718715
              ],
              [
                16.205643630524182,
                44.35053058811241
              ],
              [
                16.205863081454172,
                44.34980055308448
              ],
              [
                16.203175906187997,
                44.333057386321784
              ],
              [
                16.19966190411723,
                44.324685751311605
              ],
              [
                16.18953331778921,
                44.30851097252487
              ],
              [
                16.186639456958005,
                44.29760744521437
              ],
              [
                16.18756961160313,
                44.28241436204885
              ],
              [
                16.197078087201426,
                44.251150241534596
              ],
              [
                16.215784941977898,
                44.20815530056255
              ],
              [
                16.23211470261922,
                44.190998815079936
              ],
              [
                16.275522916849873,
                44.15735757545079
              ],
              [
                16.289992321352432,
                44.1391158309803
              ],
              [
                16.312213161550225,
                44.09999650362545
              ],
              [
                16.326889276232883,
                44.082374919838216
              ],
              [
                16.34611291583087,
                44.06847402765902
              ],
              [
                16.357378372551935,
                44.06216944866324
              ],
              [
                16.36719688541231,
                44.05813859152512
              ],
              [
                16.377945602299928,
                44.057363642146456
              ],
              [
                16.403990531403483,
                44.058758978851756
              ],
              [
                16.41401576142664,
                44.055813442787624
              ],
              [
                16.42693484077349,
                44.04051692235255
              ],
              [
                16.431482369360136,
                44.02578916618889
              ],
              [
                16.439647266324325,
                44.014007146378795
              ],
              [
                16.483468867363147,
                44.0025348439986
              ],
              [
                16.5010388667303,
                43.992716449955765
              ],
              [
                16.516541774627452,
                43.979538741770476
              ],
              [
                16.52744667499538,
                43.967859194616985
              ],
              [
                16.555815868941618,
                43.93747418081544
              ],
              [
                16.60480514170013,
                43.90106828601813
              ],
              [
                16.63736128522732,
                43.868408683470165
              ],
              [
                16.67859908776284,
                43.84068437545853
              ],
              [
                16.686143848195698,
                43.82613748443606
              ],
              [
                16.689761182541368,
                43.80931663538638
              ],
              [
                16.69823613973629,
                43.78807784936891
              ],
              [
                16.712602163824773,
                43.77151530679456
              ],
              [
                16.82380985877952,
                43.707307472610104
              ],
              [
                16.98193973124318,
                43.58969180640926
              ],
              [
                17.030515588351513,
                43.5484799529606
              ],
              [
                17.06231407485869,
                43.52774713440709
              ],
              [
                17.084569129599007,
                43.51323656872421
              ],
              [
                17.142756800207266,
                43.489336295501786
              ],
              [
                17.23949507958106,
                43.47840670288461
              ],
              [
                17.27050092343445,
                43.46321368115709
              ],
              [
                17.28641728997696,
                43.43737571993164
              ],
              [
                17.2676070597256,
                43.35332392047372
              ],
              [
                17.28993128708123,
                43.30343039938025
              ],
              [
                17.32868861393388,
                43.260358120883865
              ],
              [
                17.36940964043824,
                43.23255617563968
              ],
              [
                17.38966677865037,
                43.22309917039303
              ],
              [
                17.40020878722362,
                43.216045493282955
              ],
              [
                17.406823366011135,
                43.20542593411833
              ],
              [
                17.41519495985005,
                43.18496218560048
              ],
              [
                17.426770474537793,
                43.16571266042777
              ],
              [
                17.442066683148287,
                43.15243166446899
              ],
              [
                17.45091325934507,
                43.148151490473005
              ],
              [
                17.587380810644067,
                43.08212588388846
              ],
              [
                17.59802549206892,
                43.07290227419846
              ],
              [
                17.628411916072604,
                43.04657268090703
              ],
              [
                17.659004351650122,
                42.993655881678706
              ],
              [
                17.659107703496257,
                42.99363003122655
              ],
              [
                17.659211047918756,
                42.993449078102174
              ],
              [
                17.65931439741177,
                42.99339737722258
              ],
              [
                17.66272506259104,
                42.96569901052085
              ],
              [
                17.634509731778365,
                42.950402808400185
              ],
              [
                17.58065840150584,
                42.94208407701694
              ],
              [
                17.580088744859157,
                42.94232826048093
              ],
              [
                17.549652555039685,
                42.955308485357925
              ],
              [
                17.53451582916289,
                42.95062905468921
              ],
              [
                17.515635601001904,
                42.95888894482862
              ],
              [
                17.498545762888153,
                42.97215397774837
              ],
              [
                17.488291871918364,
                42.9826114844007
              ],
              [
                17.47461997531482,
                43.00116595580743
              ],
              [
                17.470876483210642,
                43.01341365573115
              ],
              [
                17.479177292174562,
                43.022406438963756
              ],
              [
                17.50196372914845,
                43.030991840462455
              ],
              [
                17.487966339963272,
                43.034979538613555
              ],
              [
                17.471690296993817,
                43.0304629278776
              ],
              [
                17.45337976377901,
                43.02277262610863
              ],
              [
                17.433604370078605,
                43.017401505108104
              ],
              [
                17.440684429276363,
                43.019964793284785
              ],
              [
                17.460215682169558,
                43.030991840462455
              ],
              [
                17.450450052993848,
                43.03115455952313
              ],
              [
                17.440684429713464,
                43.03229389871453
              ],
              [
                17.432302293726817,
                43.03620039982837
              ],
              [
                17.42611737581565,
                43.04462303181267
              ],
              [
                17.43360436519831,
                43.051499764060566
              ],
              [
                17.42741948038774,
                43.060858600364924
              ],
              [
                17.426117393956545,
                43.06517171692275
              ],
              [
                17.404551631194643,
                43.051499764060566
              ],
              [
                17.370860220832608,
                43.073879287248985
              ],
              [
                17.31625410388212,
                43.12726473497406
              ],
              [
                17.172373903452485,
                43.18183024094433
              ],
              [
                17.13803144676556,
                43.202337965781034
              ],
              [
                17.121348489919168,
                43.20880754075831
              ],
              [
                17.11394289212978,
                43.21320208503355
              ],
              [
                17.107757995363162,
                43.226385670233455
              ],
              [
                17.100271035849918,
                43.231675582544504
              ],
              [
                17.090179880821356,
                43.23517483962888
              ],
              [
                17.080088738364243,
                43.23651764871061
              ],
              [
                17.07349692965661,
                43.23895893637997
              ],
              [
                17.066661002250658,
                43.2448590991646
              ],
              [
                17.05632570523057,
                43.25698464797756
              ],
              [
                17.05445397366822,
                43.26121655601121
              ],
              [
                17.05111739879486,
                43.27423752284776
              ],
              [
                17.049489788998308,
                43.27802164374547
              ],
              [
                17.04509524003292,
                43.27977114475094
              ],
              [
                17.032399944164222,
                43.28237547631462
              ],
              [
                17.028168154087442,
                43.28424702561599
              ],
              [
                16.93392989006628,
                43.373602668109434
              ],
              [
                16.906016457887024,
                43.38727433631756
              ],
              [
                16.895762553653032,
                43.3945985733704
              ],
              [
                16.888519732226342,
                43.401190550613414
              ],
              [
                16.880625857671088,
                43.40595134850486
              ],
              [
                16.75245201751934,
                43.419501028694015
              ],
              [
                16.693858276146347,
                43.43829994609027
              ],
              [
                16.62582440291832,
                43.449041933263835
              ],
              [
                16.534841344584095,
                43.49713778900596
              ],
              [
                16.53345789208171,
                43.499701375718516
              ],
              [
                16.532562697079513,
                43.50433992228073
              ],
              [
                16.530039909887666,
                43.50877513082517
              ],
              [
                16.524668813565498,
                43.510809611549675
              ],
              [
                16.518565306793615,
                43.50971107604556
              ],
              [
                16.509532110382644,
                43.505072473046276
              ],
              [
                16.504405138971016,
                43.50397364735378
              ],
              [
                16.466563344574062,
                43.510809611549675
              ],
              [
                16.391449412585107,
                43.510809611549675
              ],
              [
                16.39144942512205,
                43.517645681652716
              ],
              [
                16.411387560064142,
                43.517808272530836
              ],
              [
                16.43425540316242,
                43.52187732669014
              ],
              [
                16.455902543511776,
                43.52895746084612
              ],
              [
                16.47339927765464,
                43.538153310029585
              ],
              [
                16.456797713218766,
                43.5458844149093
              ],
              [
                16.433848499360234,
                43.54975001827844
              ],
              [
                16.3367619096463,
                43.55117416444983
              ],
              [
                16.324961777217485,
                43.54852928172971
              ],
              [
                16.306325714277722,
                43.53994372318275
              ],
              [
                16.29932701173226,
                43.538153310029585
              ],
              [
                16.281097842783726,
                43.536037404279
              ],
              [
                16.239593936097915,
                43.526556602712716
              ],
              [
                16.117686397849333,
                43.52448155323998
              ],
              [
                16.117686403953016,
                43.517645681652716
              ],
              [
                16.150726757224774,
                43.511379280012385
              ],
              [
                16.16488691209615,
                43.5040957389623
              ],
              [
                16.172373905677876,
                43.48969159780476
              ],
              [
                16.11085046863345,
                43.48969159780476
              ],
              [
                16.113129115564387,
                43.47890874154135
              ],
              [
                16.098480672256848,
                43.48004799693179
              ],
              [
                16.066172733601192,
                43.48969159780476
              ],
              [
                16.039561391912905,
                43.49079008350957
              ],
              [
                16.028330923822487,
                43.49494048430324
              ],
              [
                16.014008004120424,
                43.50397364735378
              ],
              [
                16.007823108122327,
                43.50397364735378
              ],
              [
                16.007823115501772,
                43.49713778900596
              ],
              [
                15.99577885554314,
                43.50336349428489
              ],
              [
                15.973480674569306,
                43.50311931150656
              ],
              [
                15.966319204647755,
                43.510809611549675
              ],
              [
                15.965505401079085,
                43.50910061057422
              ],
              [
                15.96558678786529,
                43.5061709970046
              ],
              [
                15.964366085183812,
                43.503892354456084
              ],
              [
                15.959483264137061,
                43.50397364735378
              ],
              [
                15.961273642083574,
                43.51504149547543
              ],
              [
                15.966563343026158,
                43.5169131100127
              ],
              [
                15.974375858696678,
                43.51675051946461
              ],
              [
                15.98365318248132,
                43.521063451958256
              ],
              [
                15.986989785590232,
                43.52728919037727
              ],
              [
                15.984222847364991,
                43.53204982193616
              ],
              [
                15.982269728199185,
                43.53729890795151
              ],
              [
                15.987315295357178,
                43.544907894878165
              ],
              [
                15.970957887359033,
                43.54352457133359
              ],
              [
                15.965098502019059,
                43.54193754558279
              ],
              [
                15.959483261883793,
                43.538153310029585
              ],
              [
                15.956228066082971,
                43.54791906697462
              ],
              [
                15.948090051427679,
                43.55288332864281
              ],
              [
                15.925303568807445,
                43.558579677077354
              ],
              [
                15.941905132804568,
                43.560003851844044
              ],
              [
                15.944183801717417,
                43.56671796776292
              ],
              [
                15.935394728074614,
                43.572943438629395
              ],
              [
                15.91797935354447,
                43.572902633553625
              ],
              [
                15.917979368443454,
                43.579087690966496
              ],
              [
                15.92261804010153,
                43.5811221922436
              ],
              [
                15.927582223068411,
                43.58429592344096
              ],
              [
                15.932139525174879,
                43.58657467781739
              ],
              [
                15.922129756707514,
                43.591986424311415
              ],
              [
                15.91797935602729,
                43.593329093493715
              ],
              [
                15.9253035711319,
                43.59955463738462
              ],
              [
                15.917979351258934,
                43.60639056490143
              ],
              [
                15.925303574944223,
                43.61383690466984
              ],
              [
                15.918955934309869,
                43.628729659714736
              ],
              [
                15.929535343869214,
                43.63422263510991
              ],
              [
                15.9663192057712,
                43.633734428746976
              ],
              [
                15.966319197157587,
                43.64118062487216
              ],
              [
                15.921397330747546,
                43.64813872545874
              ],
              [
                15.904795762050348,
                43.648016593786956
              ],
              [
                15.916758663875822,
                43.653631944907495
              ],
              [
                15.926605667940697,
                43.65302158377719
              ],
              [
                15.934825060051292,
                43.64984765874394
              ],
              [
                15.942393418033921,
                43.648016593786956
              ],
              [
                15.952972846844041,
                43.6508649203718
              ],
              [
                15.95142661753475,
                43.65741595930971
              ],
              [
                15.94263756428793,
                43.66429269152197
              ],
              [
                15.93213952912873,
                43.66844321037151
              ],
              [
                15.945974156518862,
                43.672308677384734
              ],
              [
                15.952403188462482,
                43.67975492264113
              ],
              [
                15.95045006047461,
                43.68854395243365
              ],
              [
                15.938975460874975,
                43.69643793479438
              ],
              [
                15.939707867587984,
                43.67763894185685
              ],
              [
                15.931162960771033,
                43.67649978271379
              ],
              [
                15.906748881689161,
                43.69147356692947
              ],
              [
                15.892914251458778,
                43.70050682143288
              ],
              [
                15.885996942821558,
                43.70034416270988
              ],
              [
                15.87680098826968,
                43.701646348013185
              ],
              [
                15.870778849089751,
                43.703192526784605
              ],
              [
                15.864512573459518,
                43.70815672381069
              ],
              [
                15.85075930386401,
                43.72394432565663
              ],
              [
                15.84400475894913,
                43.729925901654795
              ],
              [
                15.80347739800638,
                43.74640521069158
              ],
              [
                15.792165563677676,
                43.75446201010684
              ],
              [
                15.771006698259011,
                43.75995504986725
              ],
              [
                15.706309432520868,
                43.76341371134496
              ],
              [
                15.692637567396726,
                43.77460359827061
              ],
              [
                15.682139514651617,
                43.79718654344962
              ],
              [
                15.658457869988723,
                43.80508037233129
              ],
              [
                15.632985873765978,
                43.810451573399014
              ],
              [
                15.617442241945508,
                43.82550677072988
              ],
              [
                15.647308791509953,
                43.815863364539744
              ],
              [
                15.66309654951026,
                43.81297434563935
              ],
              [
                15.678884320825942,
                43.81183513542941
              ],
              [
                15.678884313179191,
                43.81928134082088
              ],
              [
                15.673024931723804,
                43.82123439523998
              ],
              [
                15.668955928394375,
                43.820990339125856
              ],
              [
                15.666758653976558,
                43.81997298310531
              ],
              [
                15.665782099177411,
                43.81928134082088
              ],
              [
                15.638845242055348,
                43.83612695487737
              ],
              [
                15.574066615023614,
                43.859523973181126
              ],
              [
                15.546885604815765,
                43.87657289390159
              ],
              [
                15.545176627713069,
                43.877630912830575
              ],
              [
                15.524912966982274,
                43.90045818498264
              ],
              [
                15.512217634725523,
                43.91107808975663
              ],
              [
                15.497731973847372,
                43.91551348954789
              ],
              [
                15.48243247651233,
                43.91714089113317
              ],
              [
                15.47364343320412,
                43.919134923649764
              ],
              [
                15.466075061388995,
                43.921698258028435
              ],
              [
                15.45508872846455,
                43.92804586053412
              ],
              [
                15.449717638150975,
                43.934393557294484
              ],
              [
                15.44564862286943,
                43.941351506855874
              ],
              [
                15.43873131781415,
                43.949652431075016
              ],
              [
                15.384043817457512,
                43.99738191916736
              ],
              [
                15.358083536500201,
                44.025702288180554
              ],
              [
                15.339610218962466,
                44.0393740572392
              ],
              [
                15.319509316012846,
                44.04523352177898
              ],
              [
                15.277598509998509,
                44.0823429078718
              ],
              [
                15.278330927777358,
                44.08559807995782
              ],
              [
                15.233246280592066,
                44.12091695390566
              ],
              [
                15.22201582851171,
                44.125637194963545
              ],
              [
                15.212901249770947,
                44.13104902663468
              ],
              [
                15.208832227973476,
                44.13816967488687
              ],
              [
                15.212738466647256,
                44.14826069326776
              ],
              [
                15.196950724362878,
                44.15648029237793
              ],
              [
                15.144541854894424,
                44.195461239077375
              ],
              [
                15.16041100532607,
                44.21320223085239
              ],
              [
                15.152191609791435,
                44.2352970292752
              ],
              [
                15.131521035001308,
                44.254624798074275
              ],
              [
                15.110362164774868,
                44.26434956221884
              ],
              [
                15.122243673719787,
                44.27480689529055
              ],
              [
                15.140635611840239,
                44.28245676001163
              ],
              [
                15.157562691120582,
                44.28034083241618
              ],
              [
                15.16504967428702,
                44.26121653102397
              ],
              [
                15.176605675687842,
                44.24994549948801
              ],
              [
                15.197927284588866,
                44.257310340222176
              ],
              [
                15.207774277587939,
                44.27277244534486
              ],
              [
                15.185394730600663,
                44.28538650019941
              ],
              [
                15.193044459966227,
                44.28685122551189
              ],
              [
                15.19418379488213,
                44.28864172347119
              ],
              [
                15.194590679642918,
                44.2888043022874
              ],
              [
                15.199066605603903,
                44.28538650019941
              ],
              [
                15.206553585605691,
                44.28538650019941
              ],
              [
                15.201182475361017,
                44.297511970073344
              ],
              [
                15.198090045754157,
                44.3016625661659
              ],
              [
                15.247569210601988,
                44.277980901056594
              ],
              [
                15.268402532504293,
                44.25844952771782
              ],
              [
                15.279551626278028,
                44.25177640377419
              ],
              [
                15.295258008751174,
                44.25067779923909
              ],
              [
                15.281748897623524,
                44.28538650019941
              ],
              [
                15.290537961127406,
                44.28742101176128
              ],
              [
                15.294932477897696,
                44.29022847103005
              ],
              [
                15.297862165208633,
                44.29401265350607
              ],
              [
                15.302744979870077,
                44.299139625954574
              ],
              [
                15.289317256246486,
                44.30219149790075
              ],
              [
                15.278168152146034,
                44.30980038043695
              ],
              [
                15.268890828065567,
                44.32046140839234
              ],
              [
                15.261241082489857,
                44.332586986435444
              ],
              [
                15.280528186292914,
                44.3275413558214
              ],
              [
                15.308604352793296,
                44.30927143902105
              ],
              [
                15.336924680806746,
                44.3016625661659
              ],
              [
                15.408539247264166,
                44.272284117833074
              ],
              [
                15.424489793446199,
                44.26797124385143
              ],
              [
                15.503591341083473,
                44.25922271297101
              ],
              [
                15.525238484717988,
                44.260687651327615
              ],
              [
                15.528656457895083,
                44.27179609590704
              ],
              [
                15.514821808227293,
                44.278509802695915
              ],
              [
                15.449229366663234,
                44.28538650019941
              ],
              [
                15.444183783777206,
                44.288478839692736
              ],
              [
                15.414073102683744,
                44.31655496660782
              ],
              [
                15.406016463692916,
                44.320623999651986
              ],
              [
                15.307953311776567,
                44.354396775000836
              ],
              [
                15.293793175795432,
                44.364813663465604
              ],
              [
                15.155039913357541,
                44.466701602413984
              ],
              [
                15.108083537451954,
                44.513861478216825
              ],
              [
                15.080088743205732,
                44.536078250213556
              ],
              [
                15.052012562875396,
                44.545477570998955
              ],
              [
                15.047862177245925,
                44.55036044416116
              ],
              [
                15.01531009063279,
                44.56907785165469
              ],
              [
                15.007334832652775,
                44.5697289153293
              ],
              [
                15.001312691354123,
                44.578517918818015
              ],
              [
                14.901377802720052,
                44.690171647686
              ],
              [
                14.883799676295059,
                44.72361889661721
              ],
              [
                14.895192916679575,
                44.736151565701576
              ],
              [
                14.893890825486794,
                44.750962682583356
              ],
              [
                14.887461788651079,
                44.76837803816527
              ],
              [
                14.883799683935436,
                44.78876383973191
              ],
              [
                14.881358280508707,
                44.844061720626065
              ],
              [
                14.883799665069795,
                44.86147684320636
              ],
              [
                14.90528404041737,
                44.92462788940156
              ],
              [
                14.914886914949497,
                44.93992747543276
              ],
              [
                14.921641484876252,
                44.95880782832943
              ],
              [
                14.914317255604288,
                44.981431399983066
              ],
              [
                14.856455924853083,
                45.07648346434857
              ],
              [
                14.85279381609509,
                45.09365469106724
              ],
              [
                14.84253991035645,
                45.10553620400505
              ],
              [
                14.827403191047916,
                45.11395905253805
              ],
              [
                14.765961133924595,
                45.13735586014797
              ],
              [
                14.65788821778323,
                45.196600661897314
              ],
              [
                14.606700065496035,
                45.24437082925907
              ],
              [
                14.592784050363504,
                45.24982331314275
              ],
              [
                14.576019726180474,
                45.26227447164877
              ],
              [
                14.568614129038366,
                45.275946356437025
              ],
              [
                14.5822046224567,
                45.285345763806006
              ],
              [
                14.570811394088798,
                45.29364655301194
              ],
              [
                14.534353061722376,
                45.312689528257
              ],
              [
                14.55225670755018,
                45.297674878282336
              ],
              [
                14.555430534749101,
                45.295884504134285
              ],
              [
                14.551931186267916,
                45.28807201005985
              ],
              [
                14.543304883351349,
                45.28384022858494
              ],
              [
                14.533050977805262,
                45.28388093621022
              ],
              [
                14.524424675274219,
                45.28876374213725
              ],
              [
                14.51050866052545,
                45.29975007301689
              ],
              [
                14.402354364178596,
                45.338609130587976
              ],
              [
                14.36361738414283,
                45.34463125365032
              ],
              [
                14.345876497067065,
                45.35162993920346
              ],
              [
                14.329763218526272,
                45.353989993680635
              ],
              [
                14.311534050068245,
                45.34398021079072
              ],
              [
                14.290782097748437,
                45.32050202869878
              ],
              [
                14.271983269761037,
                45.29010652086241
              ],
              [
                14.258474154762235,
                45.25576406222595
              ],
              [
                14.247731967547457,
                45.18646882339913
              ],
              [
                14.234711133852576,
                45.15456777427337
              ],
              [
                14.234060092086112,
                45.15306224300767
              ],
              [
                14.232595247617608,
                45.14935943752142
              ],
              [
                14.209239129235447,
                45.126369535762024
              ],
              [
                14.179372591772172,
                45.134507551320745
              ],
              [
                14.195323112840676,
                45.1205915371274
              ],
              [
                14.193125847148696,
                45.10561758174659
              ],
              [
                14.180430534823625,
                45.09145742192381
              ],
              [
                14.164398634019381,
                45.079901434227644
              ],
              [
                14.158213737728811,
                45.08734771980289
              ],
              [
                14.154307487923173,
                45.07892487109322
              ],
              [
                14.154063347058615,
                45.0719668646902
              ],
              [
                14.158213738070724,
                45.053208726833084
              ],
              [
                14.154307488199704,
                45.05499909335476
              ],
              [
                14.14747155000721,
                45.0572777360841
              ],
              [
                14.143890821022268,
                45.05939362226206
              ],
              [
                14.14389082107064,
                45.053208726833084
              ],
              [
                14.159434440799929,
                45.04035065063922
              ],
              [
                14.166188998026442,
                45.01894765831129
              ],
              [
                14.163747580908966,
                44.995754168115354
              ],
              [
                14.15137779350764,
                44.977484365290955
              ],
              [
                14.139903190686928,
                44.971340232296626
              ],
              [
                14.13184654595614,
                44.972072610149546
              ],
              [
                14.124196800028685,
                44.97540911711776
              ],
              [
                14.113291856525112,
                44.977484365290955
              ],
              [
                14.10132898324748,
                44.97427005736879
              ],
              [
                14.089691599010449,
                44.96649807851554
              ],
              [
                14.080414266317042,
                44.95726154691877
              ],
              [
                14.075694197680045,
                44.949530230234096
              ],
              [
                14.068858259684575,
                44.949530230234096
              ],
              [
                14.071625190730904,
                44.96906152838178
              ],
              [
                14.079600453146364,
                44.97793198723617
              ],
              [
                14.083832233398352,
                44.9863956509468
              ],
              [
                14.075694207007707,
                45.004828192090564
              ],
              [
                14.05453535199101,
                45.0184593768923
              ],
              [
                14.05152428507956,
                45.026027736944904
              ],
              [
                14.053070509071764,
                45.0331485058522
              ],
              [
                14.051931185969485,
                45.03803131663681
              ],
              [
                14.04029381594029,
                45.03896718928871
              ],
              [
                14.044118685981314,
                45.02716705877723
              ],
              [
                14.039886914991762,
                45.0094261739012
              ],
              [
                14.044281445998555,
                45.001410222982
              ],
              [
                14.054698123507077,
                44.996527535952225
              ],
              [
                14.064138205986966,
                44.995754168115354
              ],
              [
                14.071543826895198,
                44.99335371242015
              ],
              [
                14.075694219379075,
                44.983710175029145
              ],
              [
                14.064789270695062,
                44.97614180803199
              ],
              [
                14.05079185524733,
                44.95648825570922
              ],
              [
                14.044444214109705,
                44.951402169680954
              ],
              [
                14.040293822060569,
                44.95636635019971
              ],
              [
                14.034678588058139,
                44.95636635019971
              ],
              [
                14.038747596771904,
                44.9494083268615
              ],
              [
                14.040212431226603,
                44.94106674211678
              ],
              [
                14.039073116868238,
                44.93183019110687
              ],
              [
                14.034678569869655,
                44.922308516339555
              ],
              [
                14.02662194912619,
                44.92405843195978
              ],
              [
                14.022471549650799,
                44.923488669831066
              ],
              [
                14.022634299976403,
                44.920599545421325
              ],
              [
                14.027842645066901,
                44.915432045730086
              ],
              [
                14.027842632520953,
                44.90863664900512
              ],
              [
                14.02271569905129,
                44.90827067112093
              ],
              [
                14.02149497847197,
                44.90737527923497
              ],
              [
                14.021739119756955,
                44.90509663663504
              ],
              [
                14.02051842523669,
                44.90110911982552
              ],
              [
                14.010590036221739,
                44.90525946185013
              ],
              [
                13.988454612711905,
                44.90078347285502
              ],
              [
                13.972666863235878,
                44.90110911982552
              ],
              [
                13.980723511877468,
                44.89655191934882
              ],
              [
                13.985850466535084,
                44.89207602817004
              ],
              [
                13.993011920370934,
                44.88129310028964
              ],
              [
                13.986175982368318,
                44.88129310028964
              ],
              [
                13.986175970050585,
                44.875067366763936
              ],
              [
                13.993011908047185,
                44.875067366763936
              ],
              [
                13.993011910954976,
                44.867621112567626
              ],
              [
                13.98585044934666,
                44.86416241031178
              ],
              [
                13.981293173122877,
                44.85980875835128
              ],
              [
                13.972666861553481,
                44.84715402164787
              ],
              [
                13.97461998753564,
                44.839667053428975
              ],
              [
                13.976328967325562,
                44.83746973793267
              ],
              [
                13.97624758378291,
                44.834906218436345
              ],
              [
                13.972666855380028,
                44.82664613456055
              ],
              [
                13.983246301966103,
                44.827053270480846
              ],
              [
                13.98943119086328,
                44.825100060289884
              ],
              [
                13.993988465630185,
                44.82050188375515
              ],
              [
                14.000010612837885,
                44.81305572905697
              ],
              [
                13.963877795674035,
                44.811834976040736
              ],
              [
                13.946299672386264,
                44.8137881215675
              ],
              [
                13.931651226680849,
                44.82050188375515
              ],
              [
                13.929698102691551,
                44.81635150589332
              ],
              [
                13.929535344824032,
                44.81525291060332
              ],
              [
                13.924815299838759,
                44.81305572905697
              ],
              [
                13.918711773788962,
                44.82904680695298
              ],
              [
                13.90967858507088,
                44.830959414012995
              ],
              [
                13.89958742480433,
                44.82904680695298
              ],
              [
                13.89014734207439,
                44.83348228559263
              ],
              [
                13.883148626428829,
                44.82664613456055
              ],
              [
                13.89389081077951,
                44.823390894651936
              ],
              [
                13.904307497799135,
                44.8172876201863
              ],
              [
                13.909353056654307,
                44.80898666859682
              ],
              [
                13.90447024147301,
                44.79877342625055
              ],
              [
                13.913422077852976,
                44.7824161656539
              ],
              [
                13.917979352960623,
                44.77826557094265
              ],
              [
                13.90316816988798,
                44.77240637600871
              ],
              [
                13.899424672152511,
                44.78196845762012
              ],
              [
                13.89975018422686,
                44.79828508090534
              ],
              [
                13.896983268839078,
                44.81305572905697
              ],
              [
                13.889659037777413,
                44.81708390442642
              ],
              [
                13.860036656486356,
                44.82566968198085
              ],
              [
                13.849131699447394,
                44.82664613456055
              ],
              [
                13.851247597634304,
                44.830023573198524
              ],
              [
                13.853851759318596,
                44.837062896854405
              ],
              [
                13.855967636409709,
                44.84027731917328
              ],
              [
                13.852793817958878,
                44.84076571570231
              ],
              [
                13.845550985938186,
                44.840155449213
              ],
              [
                13.842295761417198,
                44.84027731917328
              ],
              [
                13.849131705566274,
                44.84715402164787
              ],
              [
                13.842295778255055,
                44.8546411300448
              ],
              [
                13.831390831911396,
                44.85272871520635
              ],
              [
                13.815684443969413,
                44.85659417901594
              ],
              [
                13.799327008784918,
                44.86456927896874
              ],
              [
                13.787119981149505,
                44.875067366763936
              ],
              [
                13.794606972294764,
                44.88129310028964
              ],
              [
                13.804860862469528,
                44.87059141120554
              ],
              [
                13.819590681734931,
                44.86766173867516
              ],
              [
                13.833750857937185,
                44.87335859844458
              ],
              [
                13.842295768286139,
                44.88812896436207
              ],
              [
                13.815277538934222,
                44.88353097907823
              ],
              [
                13.804860862455197,
                44.88540260806698
              ],
              [
                13.794606969852712,
                44.894964945628864
              ],
              [
                13.794606967232836,
                44.90110911982552
              ],
              [
                13.798675981035812,
                44.90395747296774
              ],
              [
                13.803477409328272,
                44.91063059285246
              ],
              [
                13.808116083050189,
                44.915432045730086
              ],
              [
                13.796722839592018,
                44.924871986483836
              ],
              [
                13.774099143872277,
                44.963812431889274
              ],
              [
                13.732758006635997,
                44.99494046822599
              ],
              [
                13.68132571705079,
                45.04637278961942
              ],
              [
                13.673350456960751,
                45.051092840519765
              ],
              [
                13.660817905028395,
                45.06122467734649
              ],
              [
                13.64380944115406,
                45.07050202188376
              ],
              [
                13.623220247886492,
                45.07306549560876
              ],
              [
                13.627696159947522,
                45.07941315235634
              ],
              [
                13.633067254358998,
                45.08942292339287
              ],
              [
                13.636892122776395,
                45.09357330626369
              ],
              [
                13.612559441374874,
                45.11786530659159
              ],
              [
                13.638519726862341,
                45.13003164131626
              ],
              [
                13.726247591779455,
                45.134507551320745
              ],
              [
                13.706716341839394,
                45.141099349046186
              ],
              [
                13.683604362977205,
                45.143377996721284
              ],
              [
                13.636892122927998,
                45.14203522211927
              ],
              [
                13.611989779887894,
                45.13678619862653
              ],
              [
                13.60059655035399,
                45.137274485337976
              ],
              [
                13.59595787879589,
                45.14541249949671
              ],
              [
                13.597911003960325,
                45.1559512385128
              ],
              [
                13.600596550677048,
                45.16461823929359
              ],
              [
                13.599375846684696,
                45.17129140413626
              ],
              [
                13.589121941534586,
                45.17548249555241
              ],
              [
                13.593760612332598,
                45.182277727821194
              ],
              [
                13.59441165552745,
                45.18732331546151
              ],
              [
                13.590586784677182,
                45.19179921704329
              ],
              [
                13.582286004725788,
                45.196600661897314
              ],
              [
                13.582286004769008,
                45.20282624842603
              ],
              [
                13.590505404330132,
                45.20648833979341
              ],
              [
                13.594493034810332,
                45.21263255167645
              ],
              [
                13.594248893744492,
                45.22077057187066
              ],
              [
                13.589121940946061,
                45.23069895933843
              ],
              [
                13.595713738102349,
                45.24054596725154
              ],
              [
                13.595225456571747,
                45.25079986675917
              ],
              [
                13.58822675964229,
                45.25958894186074
              ],
              [
                13.575450065935915,
                45.2648786472139
              ],
              [
                13.578786655288857,
                45.2709821675367
              ],
              [
                13.584239128385379,
                45.27606841947647
              ],
              [
                13.59205162868101,
                45.279120180097294
              ],
              [
                13.602712435680726,
                45.279120180097294
              ],
              [
                13.60271243549319,
                45.285345763806006
              ],
              [
                13.592539910177868,
                45.28880443117415
              ],
              [
                13.584646030668694,
                45.29319896818087
              ],
              [
                13.578949415413497,
                45.2990176500598
              ],
              [
                13.575450066414204,
                45.30646393906883
              ],
              [
                13.585703971632132,
                45.307806703499764
              ],
              [
                13.594493034354208,
                45.311102598106416
              ],
              [
                13.609548373594645,
                45.320135816257654
              ],
              [
                13.597911005498506,
                45.32436759830383
              ],
              [
                13.571055533826536,
                45.32501860763664
              ],
              [
                13.561778189776636,
                45.326361380015946
              ],
              [
                13.550629102703935,
                45.33429597462623
              ],
              [
                13.541270380085587,
                45.34613679930951
              ],
              [
                13.54053795763703,
                45.35675691080847
              ],
              [
                13.554942253993309,
                45.36107005391713
              ],
              [
                13.554942254412003,
                45.367336335043404
              ],
              [
                13.543142122557393,
                45.376166077576585
              ],
              [
                13.513356966202348,
                45.43622466721715
              ],
              [
                13.51539147046955,
                45.43813709223339
              ],
              [
                13.51856529928738,
                45.4403343682636
              ],
              [
                13.520762566696117,
                45.443019932530134
              ],
              [
                13.515961132504065,
                45.447455126661204
              ],
              [
                13.515635613383806,
                45.448146881704
              ],
              [
                13.517832878952365,
                45.44977448041525
              ],
              [
                13.520762565708077,
                45.457261456422394
              ],
              [
                13.504567903567015,
                45.48387277143164
              ],
              [
                13.501475455521835,
                45.49860258787873
              ],
              [
                13.507090691274541,
                45.51190827336214
              ],
              [
                13.513356967274632,
                45.51190827336214
              ],
              [
                13.52312259284897,
                45.50625235638835
              ],
              [
                13.568614128060082,
                45.4907900945321
              ],
              [
                13.585139074824607,
                45.489246913287346
              ],
              [
                13.589528841717499,
                45.48883697755811
              ],
              [
                13.624106924786807,
                45.462745236733625
              ],
              [
                13.64282033577179,
                45.45944779260834
              ],
              [
                13.642920371443283,
                45.459430163589566
              ],
              [
                13.659969794051236,
                45.45997796374666
              ],
              [
                13.759294068327197,
                45.46316925493703
              ],
              [
                13.806526327859828,
                45.44213695331866
              ],
              [
                13.819858845318656,
                45.43262847182763
              ],
              [
                13.835568481138802,
                45.42911448366202
              ],
              [
                13.889001911673285,
                45.423636776099556
              ],
              [
                13.899647257443348,
                45.42921784028593
              ],
              [
                13.908432251412957,
                45.438881331919426
              ],
              [
                13.923005002463436,
                45.448958213714775
              ],
              [
                13.969823853374768,
                45.46296256129951
              ],
              [
                13.982639608056829,
                45.475313212672404
              ],
              [
                13.961452269383896,
                45.49314157369455
              ],
              [
                13.961452269857723,
                45.50389027731267
              ],
              [
                13.964966267305314,
                45.5109699427674
              ],
              [
                13.971890911041907,
                45.51422557833678
              ],
              [
                13.987476491590108,
                45.51190880880868
              ],
              [
                14.013955526589296,
                45.50797272395693
              ],
              [
                14.028321575175895,
                45.50265005887187
              ],
              [
                14.041550739616726,
                45.49319324169295
              ],
              [
                14.066665485404496,
                45.480274131219076
              ],
              [
                14.092917113308024,
                45.47391793986791
              ],
              [
                14.116747015537342,
                45.472997869571415
              ],
              [
                14.117320712199236,
                45.47297572733639
              ],
              [
                14.11968550471869,
                45.472884404971545
              ],
              [
                14.145523721716403,
                45.47624338467918
              ],
              [
                14.19306604048478,
                45.49190135265278
              ],
              [
                14.218697551442956,
                45.49717234915542
              ],
              [
                14.240608357653851,
                45.49334828397518
              ],
              [
                14.280399211850257,
                45.481100982856496
              ],
              [
                14.326804646963147,
                45.474899812130666
              ],
              [
                14.372796671856095,
                45.47784536786211
              ],
              [
                14.411243935580345,
                45.49319324169295
              ],
              [
                14.429744099168282,
                45.50538888646039
              ],
              [
                14.46891483528491,
                45.525594384256415
              ],
              [
                14.482144003295765,
                45.542440912794255
              ],
              [
                14.487414998666184,
                45.5566002361901
              ],
              [
                14.491501830620571,
                45.57916478247598
              ],
              [
                14.492272583142896,
                45.58342031062793
              ],
              [
                14.49857710868827,
                45.59618439583938
              ],
              [
                14.507878866793442,
                45.60584788903055
              ],
              [
                14.533096962830648,
                45.625691617718076
              ],
              [
                14.543638956413101,
                45.63644033368641
              ],
              [
                14.556144656097198,
                45.65669751376441
              ],
              [
                14.563896116135428,
                45.66269193388443
              ],
              [
                14.569094981327074,
                45.6642516393413
              ],
              [
                14.58094934335752,
                45.66780794866205
              ],
              [
                14.59190474261787,
                45.6633637343778
              ],
              [
                14.594075155953695,
                45.64801585978034
              ],
              [
                14.592938274187796,
                45.629670729433165
              ],
              [
                14.593868448206985,
                45.616183158028015
              ],
              [
                14.603066853372308,
                45.60357412120906
              ],
              [
                14.615985962257875,
                45.59406565691309
              ],
              [
                14.650299112624499,
                45.57484201676327
              ],
              [
                14.657327107015123,
                45.572774964169845
              ],
              [
                14.663674875327008,
                45.570187042954345
              ],
              [
                14.664045042840261,
                45.57003609992918
              ],
              [
                14.66983280247684,
                45.56455839383863
              ],
              [
                14.671693155769395,
                45.55680694340117
              ],
              [
                14.668179159526058,
                45.53913362420359
              ],
              [
                14.668489216391839,
                45.53396595614211
              ],
              [
                14.688332965839189,
                45.522028693925314
              ],
              [
                14.781143838640688,
                45.49334828397518
              ],
              [
                14.781247191640697,
                45.49334828397518
              ],
              [
                14.781350543543873,
                45.49319324169295
              ],
              [
                14.78145389734771,
                45.49314157369455
              ],
              [
                14.797163534443023,
                45.465184648151315
              ],
              [
                14.83881473914919,
                45.45898347282768
              ],
              [
                14.881602821505794,
                45.469783817370796
              ],
              [
                14.900826455342477,
                45.49314157369455
              ],
              [
                14.904443806102151,
                45.51443226203201
              ],
              [
                14.922633912106138,
                45.51494904826373
              ],
              [
                14.94537154019411,
                45.50451038807631
              ],
              [
                14.962631469339735,
                45.49314157369455
              ],
              [
                14.977340821635249,
                45.49172845096775
              ],
              [
                14.986299273948832,
                45.49086780638754
              ],
              [
                14.997461386369762,
                45.48719880711947
              ],
              [
                15.007383258531018,
                45.480842574792476
              ],
              [
                15.056165813329095,
                45.47991242961487
              ],
              [
                15.066128234995151,
                45.473933733936924
              ],
              [
                15.139261514822891,
                45.430044656059955
              ],
              [
                15.184220011460363,
                45.42560049002538
              ],
              [
                15.225849152700942,
                45.43644970062849
              ],
              [
                15.281578409554934,
                45.45097360717417
              ],
              [
                15.314031209745666,
                45.45050853306615
              ],
              [
                15.325193316483038,
                45.45283394760011
              ],
              [
                15.333874961555832,
                45.45851838880644
              ],
              [
                15.351755005610032,
                45.47614005336585
              ],
              [
                15.361366819328563,
                45.48203113098456
              ],
              [
                15.311033977016676,
                45.505905660179415
              ],
              [
                15.296667926557467,
                45.522958867399204
              ],
              [
                15.288606404327911,
                45.544559624730454
              ],
              [
                15.282611939165793,
                45.57060456560554
              ],
              [
                15.282178582887203,
                45.571494083592945
              ],
              [
                15.276720823451722,
                45.58269682225538
              ],
              [
                15.269589478185985,
                45.59344554982808
              ],
              [
                15.268555946444959,
                45.60166207217942
              ],
              [
                15.281061647280907,
                45.60615795284045
              ],
              [
                15.287882935305248,
                45.610343744096184
              ],
              [
                15.291603636961415,
                45.61825022358252
              ],
              [
                15.297391396769111,
                45.625691617718076
              ],
              [
                15.326743613342291,
                45.63225455245216
              ],
              [
                15.339145954411956,
                45.63690541067269
              ],
              [
                15.353098592902741,
                45.64031606970127
              ],
              [
                15.373769163578869,
                45.64021269274577
              ],
              [
                15.368291460063423,
                45.649049346476055
              ],
              [
                15.351961710135775,
                45.66806629571591
              ],
              [
                15.350034464932097,
                45.66961913675526
              ],
              [
                15.333874963210468,
                45.682639093514645
              ],
              [
                15.330774371025191,
                45.6845510657651
              ],
              [
                15.32705366867009,
                45.6831558086949
              ],
              [
                15.314961381512932,
                45.68088202246279
              ],
              [
                15.310413855995693,
                45.6781948526471
              ],
              [
                15.309070273006576,
                45.674164134840815
              ],
              [
                15.30493615904731,
                45.672148754282226
              ],
              [
                15.29191369318956,
                45.67555935769673
              ],
              [
                15.283025346778293,
                45.68010687824591
              ],
              [
                15.277754356655816,
                45.685016203654364
              ],
              [
                15.267832478423012,
                45.69845204077172
              ],
              [
                15.258220665303554,
                45.70511833187453
              ],
              [
                15.250882605484085,
                45.70765041401486
              ],
              [
                15.248918904808917,
                45.71183625173834
              ],
              [
                15.249912991372977,
                45.7137317686334
              ],
              [
                15.255016723716807,
                45.723463447738474
              ],
              [
                15.26349165499609,
                45.730388050590264
              ],
              [
                15.303799277466972,
                45.74614940977893
              ],
              [
                15.331031280467142,
                45.75248552680616
              ],
              [
                15.429062949763155,
                45.775294931460415
              ],
              [
                15.429754503422997,
                45.77569136917119
              ],
              [
                15.441051877833692,
                45.782167855574876
              ],
              [
                15.439501584827134,
                45.79167630685549
              ],
              [
                15.435574177967212,
                45.80211496964963
              ],
              [
                15.44032840826032,
                45.811468385478705
              ],
              [
                15.451283814217312,
                45.815137443948245
              ],
              [
                15.462549271599153,
                45.814207218847955
              ],
              [
                15.473918088874077,
                45.81157173441569
              ],
              [
                15.485390262038973,
                45.810176526259056
              ],
              [
                15.495312134281546,
                45.81265697659299
              ],
              [
                15.513915651679499,
                45.82340568938156
              ],
              [
                15.523527468608965,
                45.82681633261505
              ],
              [
                15.549748078935798,
                45.823692779320865
              ],
              [
                15.587296182756745,
                45.819219867434036
              ],
              [
                15.626053506439787,
                45.82020170459019
              ],
              [
                15.64558720151984,
                45.82412915646577
              ],
              [
                15.666051066427915,
                45.83167389448644
              ],
              [
                15.676076295620355,
                45.84169913397826
              ],
              [
                15.675456179912809,
                45.85596184351218
              ],
              [
                15.663673950847667,
                45.87606395388135
              ],
              [
                15.659436480143102,
                45.88882799406467
              ],
              [
                15.66336389129898,
                45.900816948657564
              ],
              [
                15.670391886590615,
                45.91265085471476
              ],
              [
                15.675559526523257,
                45.92515651963854
              ],
              [
                15.677109822523851,
                45.9417963714748
              ],
              [
                15.675380806626878,
                45.97248639010144
              ],
              [
                15.674215945917075,
                45.993162770459975
              ],
              [
                15.67431929748723,
                45.99331779597174
              ],
              [
                15.681967405603434,
                46.01352324043019
              ],
              [
                15.693646279685488,
                46.025770556300635
              ],
              [
                15.697987103789885,
                46.03620923705797
              ],
              [
                15.692879848095133,
                46.041635677407825
              ],
              [
                15.683931110185563,
                46.05114367809007
              ],
              [
                15.671735475299059,
                46.05739655954566
              ],
              [
                15.643726849693866,
                46.06550977413556
              ],
              [
                15.631531212104719,
                46.070574068448124
              ],
              [
                15.623604836011355,
                46.07641527720776
              ],
              [
                15.603832638498998,
                46.09098620082753
              ],
              [
                15.589880003106915,
                46.11351713118212
              ],
              [
                15.589983357823897,
                46.138683572157035
              ],
              [
                15.604349408761442,
                46.16700228684183
              ],
              [
                15.622849565578546,
                46.191703568753134
              ],
              [
                15.626571309992181,
                46.195209727072644
              ],
              [
                15.639799439765037,
                46.20767162837379
              ],
              [
                15.66129683590062,
                46.21531974275492
              ],
              [
                15.67797529253032,
                46.2144624245059
              ],
              [
                15.749766887204617,
                46.21077220945112
              ],
              [
                15.768887163145973,
                46.219350454539644
              ],
              [
                15.789144330751329,
                46.243069995345444
              ],
              [
                15.799526192972646,
                46.24860696071706
              ],
              [
                15.80309696767533,
                46.25051140053297
              ],
              [
                15.81828983251735,
                46.25552396147634
              ],
              [
                15.834206176409412,
                46.25836619520328
              ],
              [
                15.879323323874003,
                46.259308092709716
              ],
              [
                15.880894659071672,
                46.259340899733
              ],
              [
                15.883712196242092,
                46.25939969176616
              ],
              [
                15.918903308963346,
                46.272827150202836
              ],
              [
                15.948721155415502,
                46.284204462177776
              ],
              [
                15.982000767927222,
                46.288338470426304
              ],
              [
                15.993668232882902,
                46.2906132386992
              ],
              [
                15.998433882838004,
                46.29154249897574
              ],
              [
                16.019207807226,
                46.29882886971188
              ],
              [
                16.038948208018628,
                46.308440725065
              ],
              [
                16.049922403819814,
                46.31673467387356
              ],
              [
                16.052384068248127,
                46.318595024937785
              ],
              [
                16.059618771262198,
                46.33231513833123
              ],
              [
                16.059722120135962,
                46.34531171865469
              ],
              [
                16.057448362342605,
                46.35965197115892
              ],
              [
                16.057965121000347,
                46.37753197333618
              ],
              [
                16.08865430284063,
                46.373085578238445
              ],
              [
                16.094345331443577,
                46.372260991024994
              ],
              [
                16.106024209327362,
                46.37373380916223
              ],
              [
                16.115532668387882,
                46.37928898554906
              ],
              [
                16.123180786203108,
                46.38688548004053
              ],
              [
                16.131552363553723,
                46.39306076633595
              ],
              [
                16.14385136228918,
                46.39471449101279
              ],
              [
                16.153566524414725,
                46.391432968032525
              ],
              [
                16.177544391564368,
                46.375594163612256
              ],
              [
                16.19180709480639,
                46.36978064715677
              ],
              [
                16.20865360953867,
                46.36709344940458
              ],
              [
                16.21712854606386,
                46.36735184762962
              ],
              [
                16.25278527484131,
                46.373423725514776
              ],
              [
                16.27562625574491,
                46.37316532269064
              ],
              [
                16.280277144131258,
                46.376214335136495
              ],
              [
                16.27993647416365,
                46.3786612939282
              ],
              [
                16.27872685282493,
                46.387350623990464
              ],
              [
                16.274075973403615,
                46.39210485180434
              ],
              [
                16.257022743138844,
                46.39990791048553
              ],
              [
                16.25092492403948,
                46.40499803848784
              ],
              [
                16.248237758153746,
                46.41334387233691
              ],
              [
                16.25009810501338,
                46.42944104005665
              ],
              [
                16.24937463678173,
                46.437528409707326
              ],
              [
                16.23748905070269,
                46.46507188715632
              ],
              [
                16.233665003806124,
                46.478740383864505
              ],
              [
                16.234187647309724,
                46.484892339083494
              ],
              [
                16.23490523408006,
                46.493338938750604
              ],
              [
                16.260931077673405,
                46.51357604915568
              ],
              [
                16.26394738666964,
                46.515921516787834
              ],
              [
                16.295366666471217,
                46.524448215033615
              ],
              [
                16.310662880571364,
                46.53098518496007
              ],
              [
                16.329989874922145,
                46.53545528942754
              ],
              [
                16.340276423406515,
                46.54382705699917
              ],
              [
                16.34414920630978,
                46.546979028563335
              ],
              [
                16.351254474386014,
                46.53992238483923
              ],
              [
                16.35169397477732,
                46.539486029157295
              ],
              [
                16.35789513830671,
                46.546979028563335
              ],
              [
                16.369470667526613,
                46.54057124249193
              ],
              [
                16.382183063705035,
                46.53938261723994
              ],
              [
                16.394895461011174,
                46.54010604103965
              ],
              [
                16.406264286793274,
                46.539486029157295
              ],
              [
                16.415152625224604,
                46.535558546705914
              ],
              [
                16.43199914880698,
                46.523207943410824
              ],
              [
                16.440370729259588,
                46.51902213719547
              ],
              [
                16.44905236658537,
                46.51835030810992
              ],
              [
                16.470756473423094,
                46.52026239336738
              ],
              [
                16.481298464265123,
                46.51902213719547
              ],
              [
                16.49111699011232,
                46.515146442863895
              ],
              [
                16.515301560932013,
                46.50171057781757
              ]
            ]
          ],
          [
            [
              [
                18.437354779143092,
                42.55921215864365
              ],
              [
                18.44200566410269,
                42.54301165507419
              ],
              [
                18.436424595365573,
                42.510765418986296
              ],
              [
                18.437148075951868,
                42.493402249803324
              ],
              [
                18.444279425457687,
                42.477925172346815
              ],
              [
                18.454924763667094,
                42.46472177878564
              ],
              [
                18.46774051319803,
                42.45337874900884
              ],
              [
                18.475491977782124,
                42.44981307101332
              ],
              [
                18.49285525720603,
                42.44237164886055
              ],
              [
                18.49781620217146,
                42.431157940651815
              ],
              [
                18.496429890043203,
                42.41632727429827
              ],
              [
                18.474457224150846,
                42.44135160250347
              ],
              [
                18.4609481064491,
                42.44794336374687
              ],
              [
                18.427582223921526,
                42.455267615228365
              ],
              [
                18.413096547269046,
                42.46185941557386
              ],
              [
                18.411875853460586,
                42.4760196604885
              ],
              [
                18.23894290882384,
                42.559068138235894
              ],
              [
                18.220550989071278,
                42.57916912959157
              ],
              [
                18.220876501311935,
                42.58832431825269
              ],
              [
                18.223155141413685,
                42.602118205826706
              ],
              [
                18.2234806697218,
                42.614691518937356
              ],
              [
                18.217539912225323,
                42.62010327865259
              ],
              [
                18.166026228069164,
                42.626939098114924
              ],
              [
                18.124847855080198,
                42.64459873010097
              ],
              [
                18.10865320222693,
                42.64740642680402
              ],
              [
                18.09164471405179,
                42.64826068224388
              ],
              [
                18.076019713220916,
                42.651312432006456
              ],
              [
                18.063975464455293,
                42.6576196060725
              ],
              [
                18.057383662069505,
                42.66791415028439
              ],
              [
                18.077321813071755,
                42.66791415028439
              ],
              [
                18.05591882261778,
                42.683010222840814
              ],
              [
                18.04786217677804,
                42.690619225424186
              ],
              [
                18.043223493017518,
                42.7020530193802
              ],
              [
                18.02833092693954,
                42.69131095902708
              ],
              [
                18.003265806502867,
                42.70066952161825
              ],
              [
                17.961192244069384,
                42.729396779326294
              ],
              [
                17.901621933577232,
                42.75189843180026
              ],
              [
                17.880707220789837,
                42.768744146718625
              ],
              [
                17.892832867797622,
                42.79083882360617
              ],
              [
                17.86508223979729,
                42.78994387830878
              ],
              [
                17.834971564639467,
                42.807196500658556
              ],
              [
                17.806651240884495,
                42.81191643654345
              ],
              [
                17.80005942831515,
                42.81098041042299
              ],
              [
                17.79232833542427,
                42.808539272867996
              ],
              [
                17.785655141845165,
                42.80516182964589
              ],
              [
                17.780121282127855,
                42.79694237194671
              ],
              [
                17.7737736242986,
                42.798569957779954
              ],
              [
                17.767751510694385,
                42.802313669931955
              ],
              [
                17.765391478770876,
                42.80442949617301
              ],
              [
                17.758799674649975,
                42.80760325352557
              ],
              [
                17.7351180389909,
                42.82196690363931
              ],
              [
                17.720957864193053,
                42.8262391778291
              ],
              [
                17.73959395731595,
                42.813055843398594
              ],
              [
                17.748708544157246,
                42.80341231759011
              ],
              [
                17.76189213813594,
                42.7787134333112
              ],
              [
                17.76189212647875,
                42.77431878655082
              ],
              [
                17.755137577848714,
                42.77094159073909
              ],
              [
                17.7487085358984,
                42.77204016463085
              ],
              [
                17.748708545036497,
                42.77814377143725
              ],
              [
                17.75025476222437,
                42.78571206270962
              ],
              [
                17.74887127888774,
                42.79083882360617
              ],
              [
                17.728770370758422,
                42.800767238056466
              ],
              [
                17.678558800080044,
                42.81622965945849
              ],
              [
                17.633474150821254,
                42.82294338525571
              ],
              [
                17.580088741775114,
                42.84125401080452
              ],
              [
                17.525238490745476,
                42.848619020051174
              ],
              [
                17.44044029355865,
                42.87335840103987
              ],
              [
                17.442718939015503,
                42.898626949625246
              ],
              [
                17.417246946651463,
                42.91120031900377
              ],
              [
                17.35092206155011,
                42.92177959434713
              ],
              [
                17.271332230785486,
                42.96336501444519
              ],
              [
                17.237478061681884,
                42.971380933936835
              ],
              [
                17.22152755170018,
                42.97980389711375
              ],
              [
                17.213877808778427,
                42.9826114844007
              ],
              [
                17.20191490347647,
                42.98432031351919
              ],
              [
                17.09538822855509,
                42.9844425684886
              ],
              [
                17.062510625932436,
                42.990057816845436
              ],
              [
                17.046153179871567,
                42.995062452591334
              ],
              [
                17.027517118052867,
                43.00356674809676
              ],
              [
                17.017914247822752,
                43.01382058996247
              ],
              [
                17.028168152866353,
                43.02415586723203
              ],
              [
                17.02816815638805,
                43.030991840462455
              ],
              [
                17.018809445661777,
                43.03408442494754
              ],
              [
                17.012950053584028,
                43.03921120227071
              ],
              [
                17.00806726789938,
                43.045314989003714
              ],
              [
                17.001638219143807,
                43.051499764060566
              ],
              [
                17.023122579147824,
                43.048651301899014
              ],
              [
                17.055674672745823,
                43.02895740086063
              ],
              [
                17.07325278783425,
                43.02415586723203
              ],
              [
                17.158702010322052,
                43.030991840462455
              ],
              [
                17.240244997659598,
                43.02277262610863
              ],
              [
                17.39047285657607,
                42.97772862913651
              ],
              [
                17.425791868248172,
                42.96088293283169
              ],
              [
                17.454112176048845,
                42.94228751254645
              ],
              [
                17.455739780669795,
                42.9384219487352
              ],
              [
                17.455902528143476,
                42.93292865874847
              ],
              [
                17.456797733007512,
                42.92698813372473
              ],
              [
                17.460215681490602,
                42.92177959434713
              ],
              [
                17.46485435999042,
                42.92072171673384
              ],
              [
                17.476573102008945,
                42.922430620549285
              ],
              [
                17.48145591547904,
                42.92177959434713
              ],
              [
                17.499278193620803,
                42.91185133030993
              ],
              [
                17.507660345376976,
                42.90908431053567
              ],
              [
                17.518890809797426,
                42.908148392647796
              ],
              [
                17.522634306185555,
                42.91022365172844
              ],
              [
                17.522146028165096,
                42.9196230956069
              ],
              [
                17.526133650454696,
                42.92177959434713
              ],
              [
                17.53207442555477,
                42.92059978273514
              ],
              [
                17.541514527335924,
                42.91547280647476
              ],
              [
                17.546560091689077,
                42.91429270688669
              ],
              [
                17.558929897395814,
                42.91282800102206
              ],
              [
                17.568125840354114,
                42.90908431053567
              ],
              [
                17.583750841998516,
                42.90070216601275
              ],
              [
                17.622894727036595,
                42.89130280236433
              ],
              [
                17.64161216582302,
                42.88446677253768
              ],
              [
                17.65267987748024,
                42.87335840103987
              ],
              [
                17.658946153477945,
                42.87335840103987
              ],
              [
                17.6736759754041,
                42.87506743411827
              ],
              [
                17.715993678167898,
                42.84418358317483
              ],
              [
                17.741465698651634,
                42.83926023393285
              ],
              [
                17.71094810723433,
                42.85663477571311
              ],
              [
                17.70191492359659,
                42.86847578811173
              ],
              [
                17.713633664164313,
                42.8808047963382
              ],
              [
                17.70736737321303,
                42.88703023389964
              ],
              [
                17.678721553390773,
                42.879380634727184
              ],
              [
                17.653330937920874,
                42.89093671966325
              ],
              [
                17.665928998204258,
                42.90516003592365
              ],
              [
                17.679468227268806,
                42.91567623028445
              ],
              [
                17.701585736487036,
                42.91950024967586
              ],
              [
                17.723599887070865,
                42.91624454032568
              ],
              [
                17.765457807582848,
                42.904126521437774
              ],
              [
                17.786748483519396,
                42.90138752157065
              ],
              [
                17.794706651069056,
                42.90459143543548
              ],
              [
                17.80266484466148,
                42.90963011147751
              ],
              [
                17.811759871706453,
                42.90986241914895
              ],
              [
                17.823335406239206,
                42.89836454563674
              ],
              [
                17.826229280237072,
                42.88864931744188
              ],
              [
                17.825092417436856,
                42.864542432138585
              ],
              [
                17.827159478891787,
                42.853121994010564
              ],
              [
                17.85847538095983,
                42.81697417173796
              ],
              [
                17.869430770611824,
                42.81180638725611
              ],
              [
                17.90446739965489,
                42.804545927694384
              ],
              [
                17.928858699038322,
                42.79080021689524
              ],
              [
                17.971853468951043,
                42.75496240458718
              ],
              [
                17.995314559578148,
                42.74044123565622
              ],
              [
                18.04936812080193,
                42.714758168683844
              ],
              [
                18.22413782544014,
                42.62807106707511
              ],
              [
                18.257107391561668,
                42.61489359656242
              ],
              [
                18.311574347256567,
                42.601225138602445
              ],
              [
                18.338652779814304,
                42.60251688081603
              ],
              [
                18.349608202685545,
                42.596290053300756
              ],
              [
                18.36978254272153,
                42.57439288329113
              ],
              [
                18.370485479473135,
                42.57362991588939
              ],
              [
                18.38526494220915,
                42.566524441941574
              ],
              [
                18.42102500963307,
                42.563630324857904
              ],
              [
                18.437354779143092,
                42.55921215864365
              ]
            ]
          ],
          [
            [
              [
                16.858164915408782,
                42.78400305358288
              ],
              [
                16.921071812972453,
                42.77716707956188
              ],
              [
                16.93392989530068,
                42.77094159073909
              ],
              [
                16.936371285736918,
                42.75551987956834
              ],
              [
                16.92465254645438,
                42.74140052534451
              ],
              [
                16.90544681615193,
                42.73175695683214
              ],
              [
                16.884938988664416,
                42.729396779326294
              ],
              [
                16.882172071829938,
                42.7363955836821
              ],
              [
                16.874034048909245,
                42.73761626658264
              ],
              [
                16.8581649214047,
                42.74298749145966
              ],
              [
                16.847666863598384,
                42.73358796427274
              ],
              [
                16.834320497031264,
                42.730942975406386
              ],
              [
                16.82081139347769,
                42.736070048514776
              ],
              [
                16.80982506231922,
                42.74982327034152
              ],
              [
                16.82227625220175,
                42.75511317201935
              ],
              [
                16.824066594881035,
                42.76406477132797
              ],
              [
                16.818858266227384,
                42.76935452991267
              ],
              [
                16.809825060598225,
                42.76349512729062
              ],
              [
                16.802989123600423,
                42.76349512729062
              ],
              [
                16.810231957164614,
                42.77533590178632
              ],
              [
                16.828135623969043,
                42.78095135396672
              ],
              [
                16.858164915408782,
                42.78400305358288
              ]
            ]
          ],
          [
            [
              [
                17.65894617194643,
                42.74298749145966
              ],
              [
                17.679372598924825,
                42.72988522719362
              ],
              [
                17.730479363732044,
                42.713446363296605
              ],
              [
                17.748871276234944,
                42.69456601084444
              ],
              [
                17.38591557260228,
                42.77094159073909
              ],
              [
                17.37378990790374,
                42.75999581370437
              ],
              [
                17.353770369028602,
                42.76666891060912
              ],
              [
                17.33448327574571,
                42.78034095563768
              ],
              [
                17.323741071153925,
                42.79083882360617
              ],
              [
                17.34156334367071,
                42.79340237715058
              ],
              [
                17.37378989838792,
                42.80263894719261
              ],
              [
                17.392344602099886,
                42.80170324368466
              ],
              [
                17.387380398760932,
                42.80023828474795
              ],
              [
                17.382009311261445,
                42.797837634651096
              ],
              [
                17.371592633123974,
                42.79083882360617
              ],
              [
                17.38266033910269,
                42.79165260517655
              ],
              [
                17.393321154265063,
                42.791164396862186
              ],
              [
                17.40349369137054,
                42.78876379341471
              ],
              [
                17.412445514586597,
                42.78400305358288
              ],
              [
                17.419932477093706,
                42.79083882360617
              ],
              [
                17.436859579404466,
                42.7826196180078
              ],
              [
                17.486013207782836,
                42.782171849031705
              ],
              [
                17.523692265906334,
                42.76483807789674
              ],
              [
                17.57447349043611,
                42.757513602773905
              ],
              [
                17.59750409814673,
                42.74982327034152
              ],
              [
                17.59441165540577,
                42.74774811807151
              ],
              [
                17.593516480143006,
                42.74721922471871
              ],
              [
                17.590668176900223,
                42.74298749145966
              ],
              [
                17.648203967583047,
                42.73851141579803
              ],
              [
                17.65894617194643,
                42.74298749145966
              ]
            ]
          ],
          [
            [
              [
                17.13184655291369,
                42.9695499018264
              ],
              [
                17.148692239928515,
                42.95258195401933
              ],
              [
                17.164317260939832,
                42.94147377096657
              ],
              [
                17.200205915632218,
                42.92177959434713
              ],
              [
                17.193369987695366,
                42.91429270688669
              ],
              [
                17.174327012846675,
                42.92202376707494
              ],
              [
                17.153086777290536,
                42.92112856906201
              ],
              [
                17.10743248769689,
                42.91429270688669
              ],
              [
                17.015310086210757,
                42.928615567256884
              ],
              [
                16.972911005915275,
                42.92670321181455
              ],
              [
                16.898692264928627,
                42.905829282633874
              ],
              [
                16.85141034720681,
                42.90070216601275
              ],
              [
                16.739756705369164,
                42.91718169088676
              ],
              [
                16.691416861321027,
                42.92820870833632
              ],
              [
                16.672862182251574,
                42.92674395837366
              ],
              [
                16.672618025919554,
                42.92177959434713
              ],
              [
                16.65544681166953,
                42.92625560805861
              ],
              [
                16.63843834856476,
                42.93475984950955
              ],
              [
                16.706797723345293,
                42.96210359712432
              ],
              [
                16.706797724841394,
                42.9695499018264
              ],
              [
                16.687754741293887,
                42.97394426948329
              ],
              [
                16.648285362179344,
                42.97776938020542
              ],
              [
                16.631683798481507,
                42.9826114844007
              ],
              [
                16.652679886503552,
                42.992377046347826
              ],
              [
                16.674815292677177,
                42.992905915034086
              ],
              [
                16.69752038035476,
                42.990179769219885
              ],
              [
                16.720469609673195,
                42.990057816845436
              ],
              [
                16.741384323069653,
                42.9806177063964
              ],
              [
                16.768565305728057,
                42.97223547890251
              ],
              [
                16.824066603354723,
                42.96210359712432
              ],
              [
                16.878672723359138,
                42.96210359712432
              ],
              [
                16.89258872516669,
                42.96531796774783
              ],
              [
                16.915537967308804,
                42.974514171863696
              ],
              [
                17.03207442368569,
                42.9826114844007
              ],
              [
                17.111094586482157,
                42.9643007401812
              ],
              [
                17.13184655291369,
                42.9695499018264
              ]
            ]
          ],
          [
            [
              [
                16.24122155661418,
                43.07196693520734
              ],
              [
                16.24545331887656,
                43.07636137214717
              ],
              [
                16.24984785629428,
                43.079413199197056
              ],
              [
                16.253428593735215,
                43.07786705522415
              ],
              [
                16.254893428612114,
                43.06854893385824
              ],
              [
                16.25212649769904,
                43.06240468676066
              ],
              [
                16.245453332246438,
                43.057766139096806
              ],
              [
                16.233734573047002,
                43.051499764060566
              ],
              [
                16.22193444836063,
                43.04026935241096
              ],
              [
                16.21029706598737,
                43.033270520869515
              ],
              [
                16.121348512434515,
                43.01337320563666
              ],
              [
                16.087168827318067,
                43.01146080223343
              ],
              [
                16.063161661522127,
                43.017401505108104
              ],
              [
                16.08448326952054,
                43.02594636166544
              ],
              [
                16.087087446872463,
                43.041408714278944
              ],
              [
                16.079112170888358,
                43.05329006126259
              ],
              [
                16.069346552026296,
                43.051499764060566
              ],
              [
                16.06316165702547,
                43.051499764060566
              ],
              [
                16.048838747169654,
                43.06517171692275
              ],
              [
                16.052989122413557,
                43.068304683250425
              ],
              [
                16.057302292317043,
                43.07021732413061
              ],
              [
                16.062266482090784,
                43.07127524184909
              ],
              [
                16.069346556544186,
                43.07196693520734
              ],
              [
                16.092539911755086,
                43.08274976106304
              ],
              [
                16.130218933065557,
                43.08844621585549
              ],
              [
                16.17017663888607,
                43.0877140408516
              ],
              [
                16.199717648281048,
                43.079413199197056
              ],
              [
                16.19467206915161,
                43.074408250043774
              ],
              [
                16.19288171359449,
                43.07196693520734
              ],
              [
                16.215830918579055,
                43.07916894277741
              ],
              [
                16.228200717325848,
                43.07868073450975
              ],
              [
                16.24122155661418,
                43.07196693520734
              ]
            ]
          ],
          [
            [
              [
                16.69312584881441,
                43.12726473497406
              ],
              [
                16.67017663860086,
                43.125474451547326
              ],
              [
                16.55982507224989,
                43.142971161856366
              ],
              [
                16.475352411161705,
                43.16648998829495
              ],
              [
                16.445160358263514,
                43.1708031934077
              ],
              [
                16.42725670228208,
                43.17987696993612
              ],
              [
                16.41602624703616,
                43.18183024094433
              ],
              [
                16.37159265687514,
                43.19550215702437
              ],
              [
                16.375824424478648,
                43.19993734283831
              ],
              [
                16.380381696389353,
                43.201971634155285
              ],
              [
                16.391449415732207,
                43.202337965781034
              ],
              [
                16.403981975465136,
                43.19717040490868
              ],
              [
                16.415293809607988,
                43.19847233015814
              ],
              [
                16.439789258121067,
                43.209784237687785
              ],
              [
                16.446055535734665,
                43.202337965781034
              ],
              [
                16.44906660941115,
                43.206488426477584
              ],
              [
                16.46029706893393,
                43.21596912114195
              ],
              [
                16.460297070119974,
                43.209784237687785
              ],
              [
                16.496429884168638,
                43.218085029779424
              ],
              [
                16.527028836925826,
                43.204291029518146
              ],
              [
                16.554942268229368,
                43.187933810791755
              ],
              [
                16.583262572122976,
                43.18866614734431
              ],
              [
                16.55591881511488,
                43.209784237687785
              ],
              [
                16.5293074773033,
                43.22162495432728
              ],
              [
                16.52051842701406,
                43.22898999722078
              ],
              [
                16.535004089665524,
                43.227728453143115
              ],
              [
                16.562754756019203,
                43.22898999722078
              ],
              [
                16.58326256391851,
                43.21596912114195
              ],
              [
                16.587087430885948,
                43.21625391931111
              ],
              [
                16.596934453964373,
                43.22174727300028
              ],
              [
                16.603770375622638,
                43.22345608658571
              ],
              [
                16.616384323473827,
                43.223537632694935
              ],
              [
                16.646006713183205,
                43.21991614767545
              ],
              [
                16.65951581890892,
                43.21596912114195
              ],
              [
                16.666270377686878,
                43.210842176277175
              ],
              [
                16.67253664202683,
                43.203029554451994
              ],
              [
                16.680674666110956,
                43.194769505147406
              ],
              [
                16.69312585316354,
                43.18866614734431
              ],
              [
                16.69361414028068,
                43.18402752877744
              ],
              [
                16.6922306522974,
                43.1828065753596
              ],
              [
                16.68946372529952,
                43.1828065753596
              ],
              [
                16.68628991918492,
                43.18183024094433
              ],
              [
                16.7058211663628,
                43.1708031934077
              ],
              [
                16.72771244443299,
                43.16461831891479
              ],
              [
                16.751231329792617,
                43.161932827598505
              ],
              [
                16.84815514449569,
                43.16233959013013
              ],
              [
                16.864431182900486,
                43.16884996995236
              ],
              [
                16.878428587051157,
                43.158840288196735
              ],
              [
                16.89673912546761,
                43.15477118953166
              ],
              [
                16.958750854888297,
                43.15241128114373
              ],
              [
                17.01856530877511,
                43.140855299978426
              ],
              [
                17.109873899835474,
                43.143784957511414
              ],
              [
                17.155284052063912,
                43.14032625999401
              ],
              [
                17.193369989868778,
                43.12726473497406
              ],
              [
                16.943247919341598,
                43.12726473497406
              ],
              [
                16.69312584881441,
                43.12726473497406
              ]
            ]
          ],
          [
            [
              [
                16.500743024425464,
                43.28424702561599
              ],
              [
                16.42188560580691,
                43.31757225693937
              ],
              [
                16.40577234384663,
                43.33270917733637
              ],
              [
                16.413828985838876,
                43.328843638357945
              ],
              [
                16.41944421205388,
                43.325181435435645
              ],
              [
                16.426280149055984,
                43.325181435435645
              ],
              [
                16.42676843268015,
                43.33148842915385
              ],
              [
                16.42969810097443,
                43.332464783953114
              ],
              [
                16.434336787713033,
                43.33173251765393
              ],
              [
                16.43978927087117,
                43.33270917733637
              ],
              [
                16.43425539374503,
                43.339911081151925
              ],
              [
                16.4349064439065,
                43.346421594897635
              ],
              [
                16.441660989598205,
                43.35122289703788
              ],
              [
                16.453461146301493,
                43.353176303699186
              ],
              [
                16.439707887238757,
                43.37091714589459
              ],
              [
                16.426280135348954,
                43.39411032773813
              ],
              [
                16.447032083273996,
                43.39484269638734
              ],
              [
                16.453461125334616,
                43.39411032773813
              ],
              [
                16.493907108453033,
                43.38231040936173
              ],
              [
                16.687673370194183,
                43.37702054585072
              ],
              [
                16.80982507856795,
                43.353176303699186
              ],
              [
                16.809825054730947,
                43.34638081068202
              ],
              [
                16.796153179740113,
                43.34638081068202
              ],
              [
                16.806813997712094,
                43.34247467402692
              ],
              [
                16.816254103991167,
                43.34023674154741
              ],
              [
                16.824229360333167,
                43.34100980549213
              ],
              [
                16.830332867717193,
                43.34638081068202
              ],
              [
                16.839366081679255,
                43.34088775869389
              ],
              [
                16.85816491518891,
                43.325181435435645
              ],
              [
                16.868988471520844,
                43.32257715960609
              ],
              [
                16.877696164790056,
                43.32343175727343
              ],
              [
                16.885101767469397,
                43.321966951087546
              ],
              [
                16.892344602268754,
                43.31220129316732
              ],
              [
                16.879567909550985,
                43.293931428847415
              ],
              [
                16.87232507854941,
                43.28799075625953
              ],
              [
                16.864431186734098,
                43.29169343456361
              ],
              [
                16.846202032458642,
                43.27338301889587
              ],
              [
                16.813161652312484,
                43.26776761720488
              ],
              [
                16.628265811598666,
                43.263739226677096
              ],
              [
                16.563975463270943,
                43.27008704682572
              ],
              [
                16.500743024425464,
                43.28424702561599
              ]
            ]
          ],
          [
            [
              [
                16.391449404011407,
                43.34638081068202
              ],
              [
                16.37598717238042,
                43.333441445234136
              ],
              [
                16.348643436367507,
                43.33869061766772
              ],
              [
                16.28174890158688,
                43.36937091579874
              ],
              [
                16.23226973762073,
                43.384466977407406
              ],
              [
                16.20704184947052,
                43.38727433631756
              ],
              [
                16.206390828976918,
                43.391791168295924
              ],
              [
                16.207774283323975,
                43.393133838079734
              ],
              [
                16.21029705927617,
                43.393215110672216
              ],
              [
                16.213226750461136,
                43.39411032773813
              ],
              [
                16.203379765733533,
                43.39996991946057
              ],
              [
                16.20045007153303,
                43.40704993116074
              ],
              [
                16.205577032276977,
                43.412909388895095
              ],
              [
                16.220062703063647,
                43.41522865841899
              ],
              [
                16.27702882974278,
                43.411932553573756
              ],
              [
                16.298187688470303,
                43.40363182296397
              ],
              [
                16.30274497439063,
                43.38727433631756
              ],
              [
                16.329844592265033,
                43.38971583674843
              ],
              [
                16.348643427864356,
                43.378322688372045
              ],
              [
                16.366709822354732,
                43.36115133178833
              ],
              [
                16.391449404011407,
                43.34638081068202
              ]
            ]
          ],
          [
            [
              [
                15.678884304149024,
                43.648016593786956
              ],
              [
                15.740407761882178,
                43.62750900788745
              ],
              [
                15.68132572498193,
                43.640326326631694
              ],
              [
                15.672048374427844,
                43.637437257685946
              ],
              [
                15.663096548524015,
                43.64569731677783
              ],
              [
                15.619639525678286,
                43.668931455554585
              ],
              [
                15.603770382940008,
                43.67470942043269
              ],
              [
                15.61133873032558,
                43.68211489145541
              ],
              [
                15.615489130264093,
                43.676988036922936
              ],
              [
                15.619639532824207,
                43.67544195123554
              ],
              [
                15.65015710802241,
                43.67304120415193
              ],
              [
                15.661631698758956,
                43.66547263246652
              ],
              [
                15.669688348838154,
                43.65574780918688
              ],
              [
                15.678884304149024,
                43.648016593786956
              ]
            ]
          ],
          [
            [
              [
                15.261241090296645,
                43.867092283065155
              ],
              [
                15.266368024669712,
                43.85700092813156
              ],
              [
                15.342458539615102,
                43.81183513542941
              ],
              [
                15.354340031788894,
                43.80036032730134
              ],
              [
                15.367360883099751,
                43.79010662472204
              ],
              [
                15.395681195374907,
                43.77240642148555
              ],
              [
                15.38697351040288,
                43.7768416103936
              ],
              [
                15.32797286495523,
                43.796332242940736
              ],
              [
                15.308929870747498,
                43.80560929358157
              ],
              [
                15.288422059199455,
                43.82550677072988
              ],
              [
                15.261241084547503,
                43.839789158594286
              ],
              [
                15.24789472001134,
                43.84902570450216
              ],
              [
                15.233409056309638,
                43.862209447913926
              ],
              [
                15.2277938222809,
                43.87445716859592
              ],
              [
                15.240733276680444,
                43.88076415124022
              ],
              [
                15.261241090296645,
                43.867092283065155
              ]
            ]
          ],
          [
            [
              [
                15.302744990454965,
                43.96637607139702
              ],
              [
                15.297129763247641,
                43.97809489721379
              ],
              [
                15.270192897212024,
                44.00031150396895
              ],
              [
                15.261241074204607,
                44.0110536908566
              ],
              [
                15.280284040098163,
                44.01080952644645
              ],
              [
                15.296397334219936,
                44.0056013287613
              ],
              [
                15.349945515399762,
                43.97630450018544
              ],
              [
                15.378591344004207,
                43.971665779253705
              ],
              [
                15.384043803832368,
                43.970160087935696
              ],
              [
                15.386566606152398,
                43.96442296509051
              ],
              [
                15.389414906840878,
                43.94765856092564
              ],
              [
                15.391612172653616,
                43.942206095949146
              ],
              [
                15.397634298950196,
                43.93720110525703
              ],
              [
                15.411143430273954,
                43.93292883649011
              ],
              [
                15.418793159813264,
                43.92914454049887
              ],
              [
                15.426768430461081,
                43.92206458051986
              ],
              [
                15.43539472897541,
                43.911281664884584
              ],
              [
                15.442718948834548,
                43.89907464239728
              ],
              [
                15.446055531149259,
                43.8875185793422
              ],
              [
                15.438731313312747,
                43.89069242021906
              ],
              [
                15.431407101526032,
                43.89276769517782
              ],
              [
                15.423675989414422,
                43.89398848569904
              ],
              [
                15.415049666498774,
                43.89443584565233
              ],
              [
                15.407074407264647,
                43.89614483811132
              ],
              [
                15.403575079495464,
                43.90021408386265
              ],
              [
                15.40154056501064,
                43.904771270537545
              ],
              [
                15.397715678077354,
                43.9081076714693
              ],
              [
                15.37208092323783,
                43.91388578939701
              ],
              [
                15.35865319661982,
                43.91937903555928
              ],
              [
                15.34994550383642,
                43.92914454049887
              ],
              [
                15.35434002939444,
                43.93146381593858
              ],
              [
                15.356781433116797,
                43.93537004062013
              ],
              [
                15.34351647142303,
                43.93964263857295
              ],
              [
                15.32545007303634,
                43.9484317864432
              ],
              [
                15.30958092565328,
                43.9584414802879
              ],
              [
                15.302744990454965,
                43.96637607139702
              ]
            ]
          ],
          [
            [
              [
                15.254405146295136,
                44.01788974166319
              ],
              [
                15.241872582587106,
                44.02777730568297
              ],
              [
                15.232269714100672,
                44.04144914162977
              ],
              [
                15.223317911314483,
                44.05027910969831
              ],
              [
                15.212738481977935,
                44.04523352177898
              ],
              [
                15.206553586975925,
                44.04523352177898
              ],
              [
                15.205332890017075,
                44.049750190496866
              ],
              [
                15.203379743760367,
                44.05247618920872
              ],
              [
                15.201426636155341,
                44.05499917121892
              ],
              [
                15.199066597878925,
                44.05882391379402
              ],
              [
                15.18913822268795,
                44.04779700583038
              ],
              [
                15.169688339804653,
                44.05866111916882
              ],
              [
                15.148773624292387,
                44.0763612858414
              ],
              [
                15.121836777589698,
                44.09223045255567
              ],
              [
                15.087087448829637,
                44.123724821695255
              ],
              [
                15.068695512482295,
                44.1339786223122
              ],
              [
                15.070811389887162,
                44.13764064557813
              ],
              [
                15.071136927540456,
                44.138495325535544
              ],
              [
                15.072032094033434,
                44.13882067151951
              ],
              [
                15.07553144657512,
                44.140814526487986
              ],
              [
                15.071462437044312,
                44.14638907678368
              ],
              [
                15.062510620801302,
                44.16193277205089
              ],
              [
                15.225759315660968,
                44.0662296111574
              ],
              [
                15.24708092637393,
                44.0466983243593
              ],
              [
                15.254405146295136,
                44.01788974166319
              ]
            ]
          ],
          [
            [
              [
                14.84278403989904,
                44.14826069326776
              ],
              [
                14.850433795427557,
                44.15224850214758
              ],
              [
                14.857269738120019,
                44.152045116271076
              ],
              [
                14.863780142677859,
                44.148138723872044
              ],
              [
                14.869151241763056,
                44.14052973304521
              ],
              [
                14.856130414139011,
                44.136867684642475
              ],
              [
                14.835215681926643,
                44.14166890797285
              ],
              [
                14.819834826713883,
                44.15302149134642
              ],
              [
                14.82243898581898,
                44.168687102309185
              ],
              [
                14.827403186773308,
                44.15790431553229
              ],
              [
                14.835459844862914,
                44.151027883438815
              ],
              [
                14.84278403989904,
                44.14826069326776
              ]
            ]
          ],
          [
            [
              [
                15.144541864779582,
                43.949652431075016
              ],
              [
                15.216807485475266,
                43.9127871486271
              ],
              [
                15.220225456303984,
                43.90119048917713
              ],
              [
                15.195485866156645,
                43.89520897495588
              ],
              [
                15.145518426165909,
                43.9238955881592
              ],
              [
                15.133311394327725,
                43.921210031701484
              ],
              [
                15.137705932846425,
                43.91787352862406
              ],
              [
                15.140310086680126,
                43.91303125691506
              ],
              [
                15.14454185028983,
                43.9081076714693
              ],
              [
                15.169688343969812,
                43.89496487682643
              ],
              [
                15.175547715340164,
                43.89093651591528
              ],
              [
                15.183441607987486,
                43.88694902747431
              ],
              [
                15.191091338212788,
                43.8875185793422
              ],
              [
                15.196787945687724,
                43.88637917162738
              ],
              [
                15.199066600741716,
                43.877630912830575
              ],
              [
                15.194509313086149,
                43.87262606750014
              ],
              [
                15.1845809203901,
                43.877101903040014
              ],
              [
                15.175140819577678,
                43.88426339796087
              ],
              [
                15.172373890217493,
                43.8875185793422
              ],
              [
                15.136485209213665,
                43.90302140751457
              ],
              [
                15.121348517400236,
                43.91258387753724
              ],
              [
                15.10661867281673,
                43.92544164981573
              ],
              [
                15.066905145432251,
                43.969549888232265
              ],
              [
                15.042816608559457,
                43.990423969426494
              ],
              [
                15.003103048062103,
                44.052313397023916
              ],
              [
                14.983083536148516,
                44.066311009917776
              ],
              [
                14.955088724770565,
                44.0755881323105
              ],
              [
                14.870127800567301,
                44.140814526487986
              ],
              [
                14.867849166127906,
                44.152045116271076
              ],
              [
                14.862966340810262,
                44.16103748839059
              ],
              [
                14.8496199990868,
                44.17560468588843
              ],
              [
                14.855235217949868,
                44.17649969566338
              ],
              [
                14.859629755797245,
                44.176011480554635
              ],
              [
                14.863291874097008,
                44.17560468588843
              ],
              [
                14.88282311807905,
                44.159165815021105
              ],
              [
                14.939138206395516,
                44.12714252422456
              ],
              [
                14.94418378709749,
                44.12026598494848
              ],
              [
                14.948741070715965,
                44.11115130552031
              ],
              [
                14.954437685927807,
                44.10321674934112
              ],
              [
                14.962657088301388,
                44.09983948602389
              ],
              [
                14.976328958962172,
                44.096665608775766
              ],
              [
                14.98511803592313,
                44.090969153489105
              ],
              [
                14.993825707044719,
                44.087835891929814
              ],
              [
                15.007334830989935,
                44.09300363653867
              ],
              [
                15.00277753817868,
                44.08315662232332
              ],
              [
                15.000498885899678,
                44.079413061020574
              ],
              [
                15.014414922436048,
                44.0779484500833
              ],
              [
                15.022715698484062,
                44.072211089868425
              ],
              [
                15.026703329347466,
                44.06232340365626
              ],
              [
                15.027842650168179,
                44.048651503960755
              ],
              [
                15.031911663088213,
                44.036363114740375
              ],
              [
                15.041351747153968,
                44.026434502688396
              ],
              [
                15.088226748809491,
                43.98965066771801
              ],
              [
                15.099131706768636,
                43.985093489383374
              ],
              [
                15.11378013977747,
                43.9837913603053
              ],
              [
                15.116953982495113,
                43.97882733453105
              ],
              [
                15.144541864779582,
                43.949652431075016
              ]
            ]
          ],
          [
            [
              [
                14.876963734059894,
                44.55975978835788
              ],
              [
                14.865896019832094,
                44.56635151472742
              ],
              [
                14.76148522473011,
                44.658636817110825
              ],
              [
                14.743662966361807,
                44.6804874787671
              ],
              [
                14.733653188709765,
                44.70319242387376
              ],
              [
                14.738129113831945,
                44.70311120492858
              ],
              [
                14.74122155596897,
                44.70160560405575
              ],
              [
                14.77995853416689,
                44.669501091415036
              ],
              [
                14.84522545071087,
                44.60053124565048
              ],
              [
                14.883799682917056,
                44.579657383621296
              ],
              [
                14.880137556181465,
                44.60919819789101
              ],
              [
                14.904063339963672,
                44.61001203150404
              ],
              [
                14.938243026480714,
                44.59414287493929
              ],
              [
                14.966319208616888,
                44.573431726203935
              ],
              [
                14.989105666293183,
                44.54661694354532
              ],
              [
                15.003916868179434,
                44.536078250213556
              ],
              [
                15.04118899169521,
                44.527492509299584
              ],
              [
                15.051768416983606,
                44.516180641148004
              ],
              [
                15.061696819053465,
                44.500718582235535
              ],
              [
                15.075531433270456,
                44.48407609645091
              ],
              [
                15.055918809263618,
                44.486232739468676
              ],
              [
                15.028168178506416,
                44.50316004966358
              ],
              [
                15.007334840146472,
                44.504543452600615
              ],
              [
                15.01172936633229,
                44.51487868544946
              ],
              [
                15.014170775327896,
                44.51874427909863
              ],
              [
                14.972911000537076,
                44.53611884299685
              ],
              [
                14.952891469225605,
                44.54148994471317
              ],
              [
                14.942067898017806,
                44.547430652216434
              ],
              [
                14.928558790418595,
                44.552313548726325
              ],
              [
                14.91114342541813,
                44.552313548726325
              ],
              [
                14.911143421904644,
                44.545477570998955
              ],
              [
                14.965993698152547,
                44.52387129796926
              ],
              [
                15.048024931953394,
                44.43943914955932
              ],
              [
                15.096690298838142,
                44.415187879987634
              ],
              [
                15.080821158249766,
                44.424546597381855
              ],
              [
                15.064952014129435,
                44.43793360636611
              ],
              [
                15.051035992887334,
                44.45526752027916
              ],
              [
                15.041514524583498,
                44.476630012675514
              ],
              [
                15.083262561902101,
                44.46185939611203
              ],
              [
                15.176605677152288,
                44.39130293744243
              ],
              [
                15.199066603546354,
                44.381048912212414
              ],
              [
                15.213226759957518,
                44.36920808565075
              ],
              [
                15.241384302291149,
                44.351060192264036
              ],
              [
                15.25440513921616,
                44.34003321689417
              ],
              [
                15.235118047083656,
                44.336249225319385
              ],
              [
                15.211761904503808,
                44.346136669170996
              ],
              [
                15.18734783944008,
                44.359808521017136
              ],
              [
                15.165049670433826,
                44.36737696904188
              ],
              [
                15.165049668846077,
                44.36054101431296
              ],
              [
                15.182871930172155,
                44.35785541528057
              ],
              [
                15.200450068398881,
                44.349514091717836
              ],
              [
                15.21583091984479,
                44.3381207776241
              ],
              [
                15.227061395082464,
                44.32636140704052
              ],
              [
                15.206553583080998,
                44.32636140704052
              ],
              [
                15.208262553288344,
                44.32074601940086
              ],
              [
                15.210948119086968,
                44.31732825979641
              ],
              [
                15.215017129427865,
                44.3149275475783
              ],
              [
                15.220225466271918,
                44.31273031321815
              ],
              [
                15.198903840661863,
                44.31704334608331
              ],
              [
                15.154551629906871,
                44.3310000771345
              ],
              [
                15.130869988485678,
                44.332586986435444
              ],
              [
                15.130869989075624,
                44.32636140704052
              ],
              [
                15.172373886960369,
                44.30532453237099
              ],
              [
                15.172373885939342,
                44.299139625954574
              ],
              [
                15.149261904508522,
                44.30316791863197
              ],
              [
                15.128754112298964,
                44.31199790434687
              ],
              [
                15.111175968311878,
                44.32461162360652
              ],
              [
                15.096690295265622,
                44.34003321689417
              ],
              [
                15.096690312972633,
                44.34625900149173
              ],
              [
                15.11036218798438,
                44.34625900149173
              ],
              [
                15.110362177449321,
                44.35370517243979
              ],
              [
                15.10230553526279,
                44.35716380694462
              ],
              [
                15.097178572139052,
                44.36131408444463
              ],
              [
                15.089203328016769,
                44.374213036686335
              ],
              [
                15.099782743404772,
                44.37360255450335
              ],
              [
                15.106944216552968,
                44.37518962699949
              ],
              [
                15.112152549592839,
                44.37958415939908
              ],
              [
                15.117198125620344,
                44.38719324222418
              ],
              [
                15.091644734244777,
                44.399359523186426
              ],
              [
                15.083018425845001,
                44.40151602747335
              ],
              [
                15.073578333582418,
                44.40045821616734
              ],
              [
                15.057790547508755,
                44.39419164745594
              ],
              [
                15.049001501423607,
                44.39468011847805
              ],
              [
                15.038340703351867,
                44.40326583089685
              ],
              [
                15.020762578750547,
                44.42999923446632
              ],
              [
                14.95883223031406,
                44.466701602413984
              ],
              [
                14.949717631114291,
                44.468084882438916
              ],
              [
                14.897471558174022,
                44.4909122696144
              ],
              [
                14.897471552326836,
                44.497056408359754
              ],
              [
                14.90316817815127,
                44.49848068492865
              ],
              [
                14.912852404429152,
                44.50275293395952
              ],
              [
                14.918630413098283,
                44.504543452600615
              ],
              [
                14.906260614445745,
                44.520900799360156
              ],
              [
                14.877614767792025,
                44.55133684266604
              ],
              [
                14.876963734059894,
                44.55975978835788
              ]
            ]
          ],
          [
            [
              [
                14.445567264569812,
                44.5659855423152
              ],
              [
                14.526621937989999,
                44.50372952403306
              ],
              [
                14.534353048727393,
                44.48407609645091
              ],
              [
                14.51197349503634,
                44.48224507972002
              ],
              [
                14.48503665392808,
                44.50063709851091
              ],
              [
                14.451914912770626,
                44.53188714333188
              ],
              [
                14.438161658309015,
                44.5386417076467
              ],
              [
                14.438161652002785,
                44.545477570998955
              ],
              [
                14.459239140393551,
                44.541164587867485
              ],
              [
                14.466075069315451,
                44.5386417076467
              ],
              [
                14.437998883900208,
                44.564642527101576
              ],
              [
                14.422618026835245,
                44.57387920360615
              ],
              [
                14.40406335466188,
                44.579657383621296
              ],
              [
                14.39698327771568,
                44.56915934901979
              ],
              [
                14.386566606865756,
                44.5656192650003
              ],
              [
                14.37468510134678,
                44.56757244258076
              ],
              [
                14.363047723551723,
                44.573431726203935
              ],
              [
                14.363047729640058,
                44.579657383621296
              ],
              [
                14.36988366764369,
                44.579657383621296
              ],
              [
                14.369883661992043,
                44.57982007735565
              ],
              [
                14.368662947809318,
                44.58201721223438
              ],
              [
                14.364756703404513,
                44.58722561083348
              ],
              [
                14.382578967905191,
                44.603257506052714
              ],
              [
                14.375987178016835,
                44.62303298032532
              ],
              [
                14.349375839850032,
                44.655340803173786
              ],
              [
                14.344574408873717,
                44.66852440917035
              ],
              [
                14.337087434398219,
                44.69965239222082
              ],
              [
                14.33578536413123,
                44.71678308718604
              ],
              [
                14.355723494251846,
                44.70709858588069
              ],
              [
                14.381114117890998,
                44.69863502815764
              ],
              [
                14.397471556316683,
                44.685614398763164
              ],
              [
                14.39039146945439,
                44.662176795243774
              ],
              [
                14.395192909500778,
                44.65338781460012
              ],
              [
                14.399587424719371,
                44.637518490161206
              ],
              [
                14.404063356971426,
                44.61033774856395
              ],
              [
                14.410004114841417,
                44.60097905808062
              ],
              [
                14.445567264569812,
                44.5659855423152
              ]
            ]
          ],
          [
            [
              [
                14.740489118367318,
                44.77826557094265
              ],
              [
                14.740489116764731,
                44.770493742675825
              ],
              [
                14.742930526531786,
                44.76577373357851
              ],
              [
                14.754079620018336,
                44.757757846070156
              ],
              [
                14.740896029061894,
                44.76439035631636
              ],
              [
                14.724945495675458,
                44.767645423103964
              ],
              [
                14.709971551206841,
                44.76788972977057
              ],
              [
                14.699473506442189,
                44.76520419688885
              ],
              [
                14.65788821011934,
                44.79877342625055
              ],
              [
                14.670420757253638,
                44.79950579267901
              ],
              [
                14.682871934107649,
                44.79877342625055
              ],
              [
                14.69483483234257,
                44.796454172910174
              ],
              [
                14.705739792373342,
                44.79254806016811
              ],
              [
                14.70573977309687,
                44.79877342625055
              ],
              [
                14.702321824360467,
                44.80215093543762
              ],
              [
                14.701426629721464,
                44.8043480572309
              ],
              [
                14.70134525414175,
                44.80731849707231
              ],
              [
                14.699473503829775,
                44.81305572905697
              ],
              [
                14.715830917480497,
                44.80316795028463
              ],
              [
                14.71998130909023,
                44.79877342625055
              ],
              [
                14.726817247087013,
                44.79877342625055
              ],
              [
                14.714121942505885,
                44.81842684216157
              ],
              [
                14.70582114883974,
                44.82684954975479
              ],
              [
                14.692067915655972,
                44.83348228559263
              ],
              [
                14.689789252876185,
                44.836737302115246
              ],
              [
                14.68580162747965,
                44.84715402164787
              ],
              [
                14.706797712526086,
                44.8449566650259
              ],
              [
                14.726817245932647,
                44.84027731917328
              ],
              [
                14.724131719568346,
                44.84442794507188
              ],
              [
                14.719981325841875,
                44.8546411300448
              ],
              [
                14.73902427930076,
                44.85342025019786
              ],
              [
                14.753265817643882,
                44.84585191687107
              ],
              [
                14.756114142220552,
                44.83567957919504
              ],
              [
                14.740489120961287,
                44.82664613456055
              ],
              [
                14.740489117023674,
                44.82050188375515
              ],
              [
                14.74805749075213,
                44.81679925229375
              ],
              [
                14.787364115612542,
                44.78925186809398
              ],
              [
                14.811534052770778,
                44.779201596393314
              ],
              [
                14.822438997560951,
                44.771429750027735
              ],
              [
                14.851247601377564,
                44.737290863053985
              ],
              [
                14.859060087528022,
                44.71735255543108
              ],
              [
                14.849619985691735,
                44.70319242387376
              ],
              [
                14.821462432392371,
                44.72064846410417
              ],
              [
                14.772959843222047,
                44.76032148352902
              ],
              [
                14.740489118367318,
                44.77826557094265
              ]
            ]
          ],
          [
            [
              [
                14.513926626432527,
                44.662176795243774
              ],
              [
                14.508067246959147,
                44.65330630035272
              ],
              [
                14.508555534059935,
                44.645331111096624
              ],
              [
                14.514984573298168,
                44.64215732064227
              ],
              [
                14.527517127128279,
                44.64789464581245
              ],
              [
                14.534353073234394,
                44.63426355566807
              ],
              [
                14.52735435909601,
                44.62714259976443
              ],
              [
                14.520355661612255,
                44.6215273717229
              ],
              [
                14.513356969683393,
                44.618841895126536
              ],
              [
                14.502289256257788,
                44.6202659861666
              ],
              [
                14.47299238126333,
                44.6202659861666
              ],
              [
                14.42790775674355,
                44.65656169294717
              ],
              [
                14.39454187541621,
                44.70758712595821
              ],
              [
                14.397227415074797,
                44.751613733185316
              ],
              [
                14.392751491210872,
                44.752508776796134
              ],
              [
                14.389903199769215,
                44.75405518231966
              ],
              [
                14.387380397511558,
                44.75580466761086
              ],
              [
                14.383555532093252,
                44.757757846070156
              ],
              [
                14.374522320753314,
                44.753851498630034
              ],
              [
                14.368174675160358,
                44.761053779872704
              ],
              [
                14.36426843524795,
                44.774400251739955
              ],
              [
                14.363047711387074,
                44.80654519105949
              ],
              [
                14.361582869419802,
                44.81598530712872
              ],
              [
                14.356618675809912,
                44.81976947897467
              ],
              [
                14.34603924734414,
                44.82050188375515
              ],
              [
                14.329844596206085,
                44.83392974571091
              ],
              [
                14.314138215177481,
                44.893784876678204
              ],
              [
                14.294200054302985,
                44.90863664900512
              ],
              [
                14.295176636560537,
                44.91307209553383
              ],
              [
                14.296234563634574,
                44.9159202287602
              ],
              [
                14.301524272639016,
                44.922308516339555
              ],
              [
                14.29249108580003,
                44.940334421483854
              ],
              [
                14.301524287861543,
                44.94342685847446
              ],
              [
                14.325205914937928,
                44.93650938946893
              ],
              [
                14.332286016005673,
                44.9321964961733
              ],
              [
                14.350271031725143,
                44.912909267123666
              ],
              [
                14.359629742249439,
                44.90863664900512
              ],
              [
                14.377126495415748,
                44.90814847490733
              ],
              [
                14.3873803994755,
                44.909002932716795
              ],
              [
                14.393239783621977,
                44.91478103412297
              ],
              [
                14.397227404241745,
                44.92910384106708
              ],
              [
                14.393565290672033,
                44.934759724557615
              ],
              [
                14.389008008951272,
                44.950344142432776
              ],
              [
                14.39031007890567,
                44.960394445809726
              ],
              [
                14.404063337462626,
                44.949530230234096
              ],
              [
                14.41138757222075,
                44.95636635019971
              ],
              [
                14.391449420663116,
                44.96942786780311
              ],
              [
                14.376719602611734,
                44.98688392125195
              ],
              [
                14.346690299881246,
                45.047552800616785
              ],
              [
                14.340830925141233,
                45.05560944364332
              ],
              [
                14.287445509251667,
                45.10106029193785
              ],
              [
                14.278493685769403,
                45.11334869730598
              ],
              [
                14.27767988365087,
                45.127997132922076
              ],
              [
                14.288584831992946,
                45.148830470916785
              ],
              [
                14.299571160540435,
                45.162339591296615
              ],
              [
                14.313649936226641,
                45.172430733637455
              ],
              [
                14.331879102345113,
                45.17584870401068
              ],
              [
                14.356211785529107,
                45.169256909139534
              ],
              [
                14.364105664698332,
                45.15761952949951
              ],
              [
                14.360524936410098,
                45.11762116576197
              ],
              [
                14.363047721764524,
                45.09357330626369
              ],
              [
                14.369639519168125,
                45.07550690495175
              ],
              [
                14.38770592499456,
                45.0390485699358
              ],
              [
                14.412282748007987,
                45.00364817909206
              ],
              [
                14.417653853314814,
                44.997992386167574
              ],
              [
                14.430837436453013,
                44.990301830247056
              ],
              [
                14.45386802547739,
                44.98798237886397
              ],
              [
                14.466075078722403,
                44.983710175029145
              ],
              [
                14.473480655366613,
                44.971421505700405
              ],
              [
                14.471039260305599,
                44.953924887090814
              ],
              [
                14.462575718044471,
                44.93598054808365
              ],
              [
                14.451914897509033,
                44.922308516339555
              ],
              [
                14.459239130099702,
                44.915432045730086
              ],
              [
                14.449961788217509,
                44.89801670628328
              ],
              [
                14.448496939380634,
                44.883734423227054
              ],
              [
                14.45191491261457,
                44.85089755831913
              ],
              [
                14.464854372898099,
                44.82143800774457
              ],
              [
                14.46656335389587,
                44.80483640995649
              ],
              [
                14.451914903216064,
                44.79877342625055
              ],
              [
                14.457041869029965,
                44.78774655598536
              ],
              [
                14.469248896485784,
                44.773098077833865
              ],
              [
                14.472911006404551,
                44.76520419688885
              ],
              [
                14.473887575734569,
                44.75454347392345
              ],
              [
                14.467621299396711,
                44.74213298907787
              ],
              [
                14.466075068366003,
                44.7298038054736
              ],
              [
                14.472178584933715,
                44.707953226066174
              ],
              [
                14.485606302904047,
                44.69208390001866
              ],
              [
                14.501312692046307,
                44.678167990153156
              ],
              [
                14.513926626432527,
                44.662176795243774
              ]
            ]
          ],
          [
            [
              [
                14.723399297831376,
                44.943345590804284
              ],
              [
                14.706390827407835,
                44.94672279589235
              ],
              [
                14.657888205944449,
                44.97003802687349
              ],
              [
                14.628916858021396,
                44.97817611709719
              ],
              [
                14.624522331600668,
                44.98550038843424
              ],
              [
                14.623789909998502,
                45.001410222982
              ],
              [
                14.6263126959439,
                45.037258204358665
              ],
              [
                14.620860221850052,
                45.04559967528638
              ],
              [
                14.603282096937892,
                45.03896718928871
              ],
              [
                14.603282096989917,
                45.03217194188368
              ],
              [
                14.616953972030391,
                45.02464427334635
              ],
              [
                14.590668165072092,
                45.02326080982475
              ],
              [
                14.510508659989974,
                45.03217194188368
              ],
              [
                14.485362174968584,
                45.03803131663681
              ],
              [
                14.460134311109282,
                45.05239492526144
              ],
              [
                14.438731316163032,
                45.07050202188376
              ],
              [
                14.4250594407237,
                45.08734771980289
              ],
              [
                14.43311608186551,
                45.095851953444495
              ],
              [
                14.441579623107682,
                45.099798896243364
              ],
              [
                14.451182487652538,
                45.101019593988
              ],
              [
                14.462657096652265,
                45.101019593988
              ],
              [
                14.466481967202172,
                45.10529206133071
              ],
              [
                14.46583092461966,
                45.114691468614005
              ],
              [
                14.467051628609324,
                45.12409088249616
              ],
              [
                14.4763289716887,
                45.128363344413515
              ],
              [
                14.514008008748318,
                45.129055077108035
              ],
              [
                14.53012129017495,
                45.13483307700663
              ],
              [
                14.521250846992837,
                45.148830470916785
              ],
              [
                14.534190300544113,
                45.1621768312371
              ],
              [
                14.5395613945818,
                45.17039623266563
              ],
              [
                14.541758659704657,
                45.17890045461589
              ],
              [
                14.539398633575274,
                45.186835023133966
              ],
              [
                14.535899284688721,
                45.19415924343298
              ],
              [
                14.536875846899951,
                45.20172760485309
              ],
              [
                14.548024935925545,
                45.210272527147566
              ],
              [
                14.549815299873387,
                45.22142161555066
              ],
              [
                14.548838737796608,
                45.23016998667263
              ],
              [
                14.543793164722434,
                45.23574452982369
              ],
              [
                14.534353060383369,
                45.23753489094039
              ],
              [
                14.548838737335556,
                45.248724669401824
              ],
              [
                14.563324414582617,
                45.249741924231756
              ],
              [
                14.595876497380766,
                45.23753489094039
              ],
              [
                14.585459831846624,
                45.23786041724945
              ],
              [
                14.582204622381346,
                45.23753489094039
              ],
              [
                14.583994987796114,
                45.23016998667263
              ],
              [
                14.587168815390744,
                45.22435129704778
              ],
              [
                14.591319207661725,
                45.21987540054747
              ],
              [
                14.595876497182843,
                45.216498104680376
              ],
              [
                14.610687696374294,
                45.19806550126508
              ],
              [
                14.62378991057528,
                45.17548249555241
              ],
              [
                14.597422722445351,
                45.166449291082316
              ],
              [
                14.612559440664397,
                45.159247133171924
              ],
              [
                14.643728060931522,
                45.15680573022029
              ],
              [
                14.665293816226818,
                45.16181061657625
              ],
              [
                14.670909049631058,
                45.143459372807165
              ],
              [
                14.658946159625764,
                45.108343812740756
              ],
              [
                14.6652938157191,
                45.08734771980289
              ],
              [
                14.678070508839758,
                45.077460026177306
              ],
              [
                14.695974155016804,
                45.0734317081904
              ],
              [
                14.740489128877206,
                45.07306549560876
              ],
              [
                14.74000084684349,
                45.04433828122587
              ],
              [
                14.79981530002618,
                45.005194403294716
              ],
              [
                14.814952012203198,
                44.977484365290955
              ],
              [
                14.808767116206,
                44.977484365290955
              ],
              [
                14.797211133672347,
                44.971340232296626
              ],
              [
                14.784678575084437,
                44.96930565277923
              ],
              [
                14.772227409672919,
                44.971340232296626
              ],
              [
                14.760915554227946,
                44.977484365290955
              ],
              [
                14.747243674877055,
                44.97003802687349
              ],
              [
                14.747243674086102,
                44.963812431889274
              ],
              [
                14.760752790205188,
                44.95514546400453
              ],
              [
                14.75684655760623,
                44.948716625225586
              ],
              [
                14.742035358042262,
                44.94472897656994
              ],
              [
                14.723399297831376,
                44.943345590804284
              ]
            ]
          ],
          [
            [
              [
                16.310313348319973,
                43.507757893980134
              ],
              [
                16.334157760970623,
                43.50153243120519
              ],
              [
                16.375254743501824,
                43.49017964419296
              ],
              [
                16.370778842285155,
                43.4843203830106
              ],
              [
                16.333343940077395,
                43.48139062931237
              ],
              [
                16.281993042756387,
                43.48794188134016
              ],
              [
                16.26734460070469,
                43.48688389536426
              ],
              [
                16.258799684998348,
                43.483547374304315
              ],
              [
                16.246429888127093,
                43.48143142591563
              ],
              [
                16.23064211003662,
                43.48322160892895
              ],
              [
                16.218272337957647,
                43.48631425849614
              ],
              [
                16.211436382034677,
                43.49005755643082
              ],
              [
                16.21176192271105,
                43.49555093019713
              ],
              [
                16.21892338463244,
                43.49774823793637
              ],
              [
                16.223317911147163,
                43.49738196847688
              ],
              [
                16.229991070022916,
                43.49616107247212
              ],
              [
                16.24350019480666,
                43.49494048430324
              ],
              [
                16.252207866974242,
                43.49994525214171
              ],
              [
                16.248057479386386,
                43.50828675941628
              ],
              [
                16.264414916418236,
                43.512884901163154
              ],
              [
                16.310313348319973,
                43.507757893980134
              ]
            ]
          ],
          [
            [
              [
                14.759776230624201,
                44.29205955228868
              ],
              [
                14.773448100492814,
                44.285142176466145
              ],
              [
                14.791677284101576,
                44.27252843402446
              ],
              [
                14.789724155870704,
                44.26691316298482
              ],
              [
                14.775401245447712,
                44.26658771749293
              ],
              [
                14.765961126435881,
                44.26504132111067
              ],
              [
                14.75993899383023,
                44.25983302707648
              ],
              [
                14.748545782020898,
                44.261664279757106
              ],
              [
                14.738129107167909,
                44.27212154546548
              ],
              [
                14.73959395729254,
                44.28017825690467
              ],
              [
                14.749685092654344,
                44.280218824521654
              ],
              [
                14.753184428759612,
                44.28351457532999
              ],
              [
                14.753184442763,
                44.29100171525647
              ],
              [
                14.759776230624201,
                44.29205955228868
              ]
            ]
          ],
          [
            [
              [
                14.613454611502016,
                44.34080624876554
              ],
              [
                14.643565295794359,
                44.325750995350056
              ],
              [
                14.661387553233384,
                44.30866105244522
              ],
              [
                14.65739992356318,
                44.305243087207565
              ],
              [
                14.64079837156748,
                44.311835011420605
              ],
              [
                14.598887566127232,
                44.3390567094749
              ],
              [
                14.595062708959311,
                44.34711349833505
              ],
              [
                14.613454611502016,
                44.34080624876554
              ]
            ]
          ],
          [
            [
              [
                14.797862168044485,
                44.37767153746902
              ],
              [
                14.80567466766166,
                44.367824527118316
              ],
              [
                14.811208534236771,
                44.350043084428336
              ],
              [
                14.801036008924298,
                44.34308508433391
              ],
              [
                14.785166856913017,
                44.3468691382939
              ],
              [
                14.774180546566063,
                44.352484574530365
              ],
              [
                14.75619550585357,
                44.36399970591057
              ],
              [
                14.75782311561438,
                44.372259862976726
              ],
              [
                14.768239788062413,
                44.38422281535785
              ],
              [
                14.763438334378874,
                44.41535050846789
              ],
              [
                14.767100459017753,
                44.416652759099115
              ],
              [
                14.771657757307585,
                44.417873546520504
              ],
              [
                14.782888218790736,
                44.418931402477575
              ],
              [
                14.794769728286845,
                44.414496175704556
              ],
              [
                14.803233257386982,
                44.40550351534195
              ],
              [
                14.805023624544859,
                44.395737914982504
              ],
              [
                14.799652551351228,
                44.3876408217468
              ],
              [
                14.796722847744093,
                44.38129298733682
              ],
              [
                14.797862168044485,
                44.37767153746902
              ]
            ]
          ],
          [
            [
              [
                14.244151235452016,
                44.661444372909855
              ],
              [
                14.26579836969259,
                44.679510770015405
              ],
              [
                14.280446809377912,
                44.67755766489904
              ],
              [
                14.280039902898576,
                44.667791975359485
              ],
              [
                14.274180541051305,
                44.66168861530842
              ],
              [
                14.260915567521588,
                44.65949135492564
              ],
              [
                14.259450721356908,
                44.65818924639844
              ],
              [
                14.257334837633353,
                44.65672441746827
              ],
              [
                14.256846560703202,
                44.653062368301974
              ],
              [
                14.258474166345884,
                44.64785404188514
              ],
              [
                14.256358278948316,
                44.64240155142301
              ],
              [
                14.256683789907614,
                44.637030339908705
              ],
              [
                14.259043805992103,
                44.634100534874406
              ],
              [
                14.265798380586032,
                44.62539306051173
              ],
              [
                14.271169479727476,
                44.61253504816117
              ],
              [
                14.264007997372993,
                44.61155819774956
              ],
              [
                14.252207889755557,
                44.61684817605339
              ],
              [
                14.239756702085128,
                44.61985905889285
              ],
              [
                14.232595239290509,
                44.626043908992344
              ],
              [
                14.233571822680664,
                44.63483321311281
              ],
              [
                14.235606303594718,
                44.642238527360554
              ],
              [
                14.244151235452016,
                44.661444372909855
              ]
            ]
          ]
        ]
      }
    }
  ]
};

export default croatiaShape;